import type { Translations } from "./types";

export const he: Translations = {
  // Common
  save: "שמור",
  cancel: "ביטול",
  delete: "מחק",
  loading: "טוען...",
  back: "חזור",
  search: "חיפוש",
  close: "סגור",
  confirm: "אישור",
  edit: "עריכה",
  create: "צור",
  copy: "העתק",
  copied: "הועתק",
  download: "הורד",
  upload: "העלה",
  settings: "הגדרות",
  profile: "פרופיל",
  logout: "התנתק",
  login: "התחבר",
  signup: "הרשמה",

  // Navigation
  nav_home: "ראשי",
  nav_explore: "גלה",
  nav_community: "קהילה",
  nav_messages: "הודעות",
  nav_settings: "הגדרות",
  nav_profile: "פרופיל",

  // Settings - Appearance
  settings_appearance: "מראה",
  settings_appearance_desc: "התאם את המראה והתחושה של הממשק.",
  settings_theme: "ערכת נושא",
  settings_theme_desc: "בחר בין ערכות נושא בהירות וכהות לממשק.",
  settings_theme_light: "בהיר",
  settings_theme_light_desc: "קלף חם",
  settings_theme_dark: "כהה",
  settings_theme_dark_desc: "מרתף אפל",
  settings_theme_system: "מערכת",
  settings_theme_system_desc: "התאם למכשיר",
  settings_language: "שפה",
  settings_language_desc: "בחר את שפת הממשק המועדפת עליך.",
  locale_auto_detect: "אוטומטי (זיהוי)",
  settings_login_bg: "רקע התחברות",
  settings_login_bg_desc: "הגדר תמונת רקע מותאמת אישית לדף ההתחברות וההרשמה.",
  settings_login_bg_url_placeholder: "https://example.com/background.jpg",
  settings_login_bg_hint: "הדבק כתובת URL לתמונת רקע. השאר ריק לשימוש ברירת המחדל.",

  // Settings - AI
  settings_ai: "ספק AI",
  settings_ai_desc: "הגדר מודלים, מפתחות API וכלי מחקר אינטרנט.",
  settings_provider: "ספק",
  settings_provider_desc: "בחר בין Lovable AI המובנה למפתח Gemini API שלך.",
  settings_use_own_key: "השתמש במפתח Gemini API שלי",
  settings_using_own_key: "משתמש במפתח Gemini API האישי שלך",
  settings_using_lovable: "משתמש ב-Lovable AI המובנה (מומלץ)",
  settings_lovable_ready: "✨ Lovable AI מוכן לשימוש — ללא הגדרה נדרשת! תומך במודלים של Gemini ו-GPT.",
  settings_test_connection: "בדיקת חיבור",
  settings_test_key: "בדוק מפתח API",
  settings_test_lovable: "בדוק Lovable AI",
  settings_testing: "בודק...",

  // Settings - Voice
  settings_voice: "קול",
  settings_voice_desc: "הגדר ספקי המרת טקסט לדיבור וקולות.",
  settings_tts_provider: "ספק המרת טקסט לדיבור",
  settings_tts_provider_desc: "בחר איזה מנוע TTS מפעיל את השמעת הקריינות.",
  settings_default_voice: "קול ברירת מחדל למספר",
  settings_available_voices: "קולות זמינים",

  // Settings - Credits
  settings_credits: "קרדיטים",
  settings_credits_desc: "הארנק שלך, תוכנית הפניות ופרטי תמחור קרדיטים.",

  // Settings - Analytics
  settings_analytics: "ניתוח נתונים",
  settings_analytics_desc: "מדדי שימוש ב-AI ויומן פעילות.",

  // Settings - Tools
  settings_tools: "כלים ואבחון",
  settings_tools_desc: "פאנלי בדיקה וחבילות אבחון.",

  // Settings tabs
  tab_appearance: "מראה",
  tab_ai_provider: "ספק AI",
  tab_credits: "קרדיטים",
  tab_voice: "קול",
  tab_music_library: "ספריית מוזיקה",
  tab_analytics: "ניתוח",
  tab_error_logs: "יומני שגיאות",
  tab_tools: "כלים",

  // Profile
  profile_title: "פרופיל",
  profile_display_name: "שם תצוגה",
  profile_email: "דוא״ל",
  profile_bio: "ביוגרפיה",
  profile_signature: "חתימת פורום",
  profile_public: "פרופיל ציבורי",
  profile_avatar: "תמונת פרופיל",
  profile_change_password: "שנה סיסמה",
  profile_current_password: "סיסמה נוכחית",
  profile_new_password: "סיסמה חדשה",
  profile_confirm_password: "אשר סיסמה חדשה",
  profile_update: "עדכן פרופיל",
  profile_friends: "חברים",
  profile_delete_account: "מחק חשבון",
  profile_delete_confirm: "האם אתה בטוח שברצונך למחוק את חשבונך? פעולה זו אינה ניתנת לביטול.",

  // Dashboard
  dashboard_worlds: "עולמות",
  dashboard_adventures: "הרפתקאות",
  dashboard_create_world: "צור עולם",
  dashboard_no_worlds: "אין עולמות עדיין",
  dashboard_no_adventures: "אין הרפתקאות עדיין",

  // Play
  play_your_turn: "התור שלך",
  play_send: "שלח",
  play_type_action: "מה אתה עושה?",

  // World Builder
  world_builder: "בונה עולמות",
  world_entities: "ישויות",
  world_plots: "עלילות",
  world_mechanics: "מכניקות",
  world_scenarios: "תרחישים",

  // Misc
  no_results: "לא נמצאו תוצאות",
  error_occurred: "אירעה שגיאה",
  success: "הצלחה",

  // ── Auth ──
  auth_sign_in: "התחבר",
  auth_sign_up: "הצטרף לרשימת ההמתנה",
  auth_signing_in: "מתחבר…",
  auth_signing_up: "מצטרף לרשימה…",
  auth_sign_in_subtitle: "התחבר כדי להמשיך בהרפתקה שלך",
  auth_sign_up_subtitle: "הצטרף לרשימת ההמתנה של הבטא — נעדכן אותך במייל כשהת��ר שלך מגיע",
  auth_reset_password: "איפוס סיסמה",
  auth_reset_subtitle: "הזן את כתובת הדוא״ל שלך ונשלח לך קישור לאיפוס",
  auth_forgot_password: "שכחת סיסמה?",
  auth_send_reset_link: "שלח קישור לאיפוס",
  auth_sending: "שולח…",
  auth_no_account: "עוד אין לך חשבון? הצטרף לרשימת ההמתנה",
  auth_has_account: "כבר יש לך חשבון? התחבר",
  auth_back_to_sign_in: "חזרה להתחברות",
  auth_email: "דוא״ל",
  auth_password: "סיסמה",
  auth_display_name: "שם תצוגה",
  auth_email_placeholder: "you@example.com",
  auth_password_placeholder: "••••••••",
  auth_password_signup_placeholder: "לפחות 6 תווים",
  auth_password_min: "מינימום 6 תווים",
  auth_name_placeholder: "השם שלך",
  auth_referral_bonus: "הופנית! הבקשה שלך תקבל עדיפות",
  auth_daily_bonus: "בונוס יומי: +{credits} נקודות!",
  auth_welcome_back: "ברוך שובך!",
  auth_check_email: "בדוק את הדוא״ל שלך לאישור מקומך ברשימת ההמתנה!",
  auth_reset_sent: "קישור לאיפוס סיסמה נשלח! בדוק את תיבת הדואר.",
  auth_enter_email: "אנא הזן את כתובת הדוא״ל שלך.",

  // ── AppHeader / Nav ──
  nav_worlds: "עולמות",
  nav_about: "אודות",
  nav_roadmap: "מפת דרכים",
  nav_pricing: "תמחור",
  nav_contact: "צור קשר",
  nav_forums: "פורומים",
  nav_users: "משתמשים",
  nav_sign_in_up: "התחבר / הצטרף לרשימה",
  nav_guest_browsing: "אתה גולש כאורח",
  nav_set_display_name: "הגדר שם תצוגה",
  nav_user_management: "ניהול משתמשים",
  nav_sign_out: "התנתק",
  nav_active_tasks: "משימות פעילות",
  nav_clear: "נקה",
  gh_open_menu: "פתח תפריט",
  gh_menu: "תפריט",
  gh_account: "חשבון",
  gh_credits: "קרדיטים",
  nav_your_credits: "הקרדיטים שלך",
  nav_no_credits: "אין קרדיטים — כל תכונות ה-AI מושבתות",
  nav_low_credits: "קרדיטים נמוכים — בניית עולמות מושבתת",
  nav_transfers_disabled: "קרדיטים מתחת ל-100 — העברות מושבתות",

  // Task phases
  task_searching: "מחפש באינטרנט",
  task_writing_brief: "כותב בריף",
  task_generating: "מייצר תמונה",
  task_complete: "הושלם",
  task_failed: "נכשל",

  // ── Index / Dashboard (extended) ──
  idx_tagline: "בנה עולמות עם AI, ואז שחק בהם כהרפתקאות טקסט.",
  idx_my_worlds: "העולמות שלי",
  idx_my_adventures: "ההרפתקאות שלי",
  idx_public_worlds: "עולמות ציבוריים",
  idx_trash: "אשפה",
  idx_new_world: "עולם חדש",
  idx_create_new_world: "צור עולם חדש",
  idx_manual: "ידני",
  idx_manual_desc: "כותרת ותיאור",
  idx_ai_prompt: "פרומפט AI",
  idx_ai_prompt_desc: "תאר ותן ל-AI לבנות",
  idx_world_name_placeholder: "שם העולם (השאר ריק ליצירה אוטומטית)...",
  idx_world_desc_placeholder: "תיאור קצר (השאר ריק ליצירה אוטומטית)...",
  idx_world_prompt_placeholder: "תאר את העולם שברצונך ליצור... למשל 'עולם פנטזיה אפל בהשראת Bloodborne, עם אלמנטים של אימה קוסמית ורבעי עיר מחוברים'",
  idx_reference_files: "קבצי עזר (אופציונלי)",
  idx_terms_title: "⚠️ תנאים והצהרה",
  idx_terms_content_1: "ביצירת עולם אתה מאשר שיש לך בעלות או זכויות על כל המדיה והתוכן שהועלו. אתה מקבל אחריות מלאה על כל חומר שאתה מעלה.",
  idx_terms_content_2: "תוכן שנוצר על ידי AI (טקסט, תמונות, תרחישים) מסופק כמות שהוא ללא ערבויות לדיוק, התאמה או מטרה כלשהי. אנו לא נושאים באחריות על תוצרי AI.",
  idx_create_with_ai: "צור עם AI",
  idx_create_and_build: "צור והתחל לבנות",
  idx_no_worlds_hint: "אין עולמות עדיין. צור את העולם הראשון שלך!",
  idx_your_worlds: "העולמות שלך",
  idx_shared_with_you: "שותפו איתך",
  idx_new_game: "משחק חדש",
  idx_join_game: "הצטרף למשחק",
  idx_join_game_title: "הצטרף למשחק",
  idx_join_game_desc: "הזן קוד הזמנה או הדבק קישור הזמנה כדי להצטרף להרפתקה מרובת משתתפים.",
  idx_invite_code_placeholder: "קוד הזמנה...",
  idx_join: "הצטרף",
  idx_joining_adventure: "מצטרף להרפתקה...",
  idx_select_world: "בחר עולם",
  idx_choose_world: "בחר עולם לשחק בו...",
  idx_no_worlds_available: "אין עולמות זמינים. בנה עולם קודם!",
  idx_select_or_new_adventure: "המשך הרפתקה קיימת או התחל חדשה.",
  idx_or: "או",
  idx_your_turn: "התור שלך",
  idx_adventures: "הרפתקאות",
  idx_no_adventures_hint: "אין הרפתקאות עדיין. התחל משחק חדש או הצטרף לאחד!",
  idx_trashed_worlds: "עולמות שנמחקו",
  idx_trash_desc: "עולמות שנמחקו נשמרים כאן. שחזר אותם או מחק לצמיתות.",
  idx_trash_empty: "האשפה ריקה",
  idx_restore: "שחזר",
  idx_delete_forever: "מחק לצמיתות",
  idx_delete_forever_title: "למחוק את העולם הזה לצמיתות?",
  idx_delete_forever_desc: "וכל הישויות, העלילות, הסוכנים והמדיה שלו יימחקו לצמיתות. לא ניתן לבטל פעולה זו.",
  idx_no_public_worlds: "אין עולמות ציבוריים זמינים עדיין.",
  idx_solo: "סולו",
  idx_joined: "הצטרפת",
  idx_yours: "שלך",
  idx_updated: "עודכן",
  idx_deleted: "נמחק",
  idx_turn: "תור",
  idx_drop_files: "גרור קבצים לכאן או השתמש בכפתור העלאה",
  idx_start_new_game: "התחל משחק חדש",

  // ── Profile (extended) ──
  profile_account_settings: "הגדרות חשבון",
  profile_account_settings_desc: "נהל את הפרופיל והאבטחה שלך",
  profile_info: "פרטי פרופיל",
  profile_info_desc: "עדכן את הפרטים האישיים שלך",
  profile_achievements: "הישגים",
  profile_avatar_hint: "העלה תמונה או הדבק כתובת URL ישירה.",
  profile_name_placeholder: "הזן את שם התצוגה שלך",
  profile_name_hint: "כך שחקנים אחרים יראו אותך",
  profile_email_readonly: "לא ניתן לשנות דוא״ל",
  profile_bio_placeholder: "ספר על עצמך...",
  profile_avatar_url_placeholder: "https://example.com/avatar.jpg",
  profile_signature_placeholder: "זה מופיע מתחת לפוסטים שלך בפורום...",
  profile_signature_hint: "עד 240 תווים.",
  profile_public_hint: "אפשר לאחרים לראות את הפרופיל שלך",
  profile_tab_byok: "BYOK",
  profile_secret_mode: "מצב סודי",
  profile_secret_mode_desc: "הסתר את עצמך מחיפוש שחקנים. חברים קיימים עדיין יכולים לראות אותך.",
  profile_save_changes: "שמור שינויים",
  profile_updating: "מעדכן...",
  profile_password_desc: "עדכן את סיסמת החשבון שלך",
  profile_password_changing: "משנה...",
  profile_account_actions: "פעולות חשבון",
  profile_account_actions_desc: "נהל את החשבון שלך",
  profile_logout_confirm: "האם אתה בטוח?",
  profile_logout_confirm_desc: "תנותק מהחשבון שלך.",

  // ── Play ──
  play_what_do_you_do: "מה אתה עושה?",
  play_waiting_turn: "ממתין לתור של שחקן אחר...",
  play_debug_log: "הורד יומן ניפוי באגים",
  play_adventure_state: "מצב ההרפתקה",

  // ── World Builder (extended) ──
  wb_title: "בונה עולמות",
  wb_empty_desc: "תאר קונספט עולם ואני אצור ישויות, מיקומים, דמויות ועלילות.",
  wb_describe_placeholder: "תאר את העולם שלך...",
  wb_describe_placeholder_full: "Enter לשלוח · Shift+Enter לשורה חדשה · Ctrl+Enter לתור",
  wb_shuffle: "ערבב הצעות",
  wb_show_older: "הצג ישנים יותר",
  wb_queue: "תור",
  wb_queue_paused: "מושהה",
  wb_send_queue: "שלח תור",
  wb_resume: "חדש",
  wb_pause: "השהה",
  wb_unpause: "בטל השהיה",
  wb_clear: "נקה",
  wb_stop: "עצור",
  wb_retry: "חדש / נסה שוב",
  wb_unsaved: "לא נשמר",
  wb_unsaved_title: "שינויים לא שמורים",
  wb_unsaved_desc: "יש לך שינויים שלא נשמרו. האם ברצונך לשמור לפני עזיבה?",
  wb_leave_without_saving: "עזוב בלי לשמור",
  wb_save_and_leave: "שמור וצא",
  wb_read_only: "קריאה בלבד",
  wb_update: "עדכון",
  wb_full_access: "גישה מלאה",
  wb_debug_dump: "הורד דמפ ניפוי",
  wb_panel_title: "פאנל בונה עולמות",

  // ── World Builder Panel (CreationPanel) ──
  wb_entities: "ישויות",
  wb_save: "שמור",
  wb_saved: "נשמר",
  wb_play: "שחק",
  wb_play_adventure: "שחק הרפתקה",
  wb_ui_version_label: "ממשק בונה",
  wb_ui_version_desc: "בחר באיזה ממשק בונה עולמות להשתמש.",
  wb_ui_version_v1: "V1",
  wb_ui_version_v2: "V2",
  flow_version_label: "מנוע זרימה",
  flow_version_desc: "V2 משתמש בצינור Agents SDK (ניסיוני).",
  flow_version_v1: "V1 — קלאסי",
  flow_version_v2: "V2 — SDK",
  wb_v2_canvas_hint: "קנבס V2 — בפיתוח",
  wb_v2_empty: "אין עדיין ישויות — בקש מהסוכן לבנות את העולם שלך",
  wb_v2_actions: "פעולות",
  wb_v2_action_add: "הוסף",
  wb_v2_action_generate: "צור",
  wb_v2_action_layout: "פריסה",
  wb_v2_action_settings: "הגדרות",
  wb_v2_coming_soon: "בקרוב",
  wb_loading_adventures: "טוען הרפתקאות...",
  wb_continue_playing: "המשך לשחק",
  wb_or_start_new: "או התחל חדש",
  wb_adventure_name: "שם ההרפתקה...",
  wb_multiplayer: "מרובה משתתפים",
  wb_multiplayer_desc: "הזמן אחרים להצטרף",
  wb_turn_mode: "מצב תורות",
  wb_free_form: "חופשי",
  wb_round_robin: "תור סיבובי",
  wb_create_mp: "צור הרפתקה מרובת משתתפים",
  wb_begin_new: "התחל הרפתקה חדשה",
  wb_share: "שתף",
  wb_world_banner: "באנר העולם",
  wb_trash: "פח אשפה",
  wb_section_build: "בנייה",
  wb_section_statistics: "סטטיסטיקות",
  wb_section_feedback: "משוב",
  wb_section_publishing: "פרסום",
  wb_group_general: "כללי",
  wb_group_data: "נתונים",
  wb_group_media: "מדיה",
  wb_group_engine: "מנוע",
  wb_group_agents: "סוכנים",
  wb_tab_world_gen: "יצירת עולם",
  wb_tab_checklist: "רשימת משימות",
  wb_tab_locations: "מיקומים",
  wb_tab_map: "מפה",
  wb_tab_entities: "ישויות",
  wb_tab_plot: "עלילה",
  wb_tab_context: "הקשר",
  wb_tab_media: "ספריית מדיה",
  wb_tab_voice: "הגדרות קול",
  wb_tab_music: "מוזיקה",
  wb_tab_mechanics: "מכניקות",
  wb_tab_scenarios: "תרחישים",
  wb_tab_players: "שחקנים",
  wb_tab_agents: "ספריית סוכנים",
  wb_tab_chats: "צ׳אטים",
  wb_tab_about: "אודות",
  wb_tab_privacy: "פרטיות ושיתוף",
  wb_tab_actions: "פעולות",
  wb_tab_design_issues: "משוב על המשחק",
  wb_quick_create: "צור חדש",
  wb_describe_create: "תאר מה ליצור...",
  wb_send: "שלח",
  wb_tab_promotion: "קידום",
  wb_section_instances: "משחקים פעילים",
  wb_group_general_desc: "זהות העולם והגדרות",
  wb_group_data_desc: "תוכן העולם וידע",
  wb_group_media_desc: "נכסים חזותיים וקוליים",
  wb_group_engine_desc: "חוקים, תרחישים ושחקנים",
  wb_group_agents_desc: "סוכני AI ושיחות",
  wb_quick_new_entity: "צור ישות חדשה ומעניינת שמתאימה לעולם",
  wb_quick_new_plot: "צור עלילה חדשה או קשר סיפורי לעולם הזה",
  wb_quick_new_agent: "צור סוכן AI חדש לעולם הזה",
  wb_quick_new_location: "צור מיקום חדש לעולם הזה",

  // ── World AI Provider ──
  ai_title: "ספק AI",
  ai_desc: "הגדר איזה ספק AI ומודל העולם הזה משתמש בו. כל עולם יכול להשתמש בספק אחר.",
  ai_membership_required: "נדרשת מנוי",
  ai_membership_desc: "הגדרת ספק AI לכל עולם דורשת מנוי פעיל עם הגדרת BYOK (הבא מפתח משלך). עבור לפרופיל → מפתחות API כדי להגדיר את החשבונות שלך.",
  ai_use_custom: "השתמש ב-AI מותאם אישית לעולם זה",
  ai_use_custom_desc: "דרוס את ברירת המחדל של ה-AI של הפלטפורמה עם ספק BYOK שלך לכל קריאות AI בעולם זה.",
  ai_no_accounts: "אין חשבונות טקסט",
  ai_no_accounts_desc: "עדיין לא הגדרת חשבונות טקסט BYOK. עבור לפרופיל → מפתחות API → לשונית טקסט כדי להוסיף אחד.",
  ai_account_label: "חשבון AI",
  ai_select_account: "בחר חשבון",
  ai_default_account: "חשבון BYOK ברירת מחדל",
  ai_account_hint: "בחר באיזה חשבון טקסט BYOK להשתמש לקריאות AI בעולם זה. \"ברירת מחדל\" משתמש בחשבון שמסומן כברירת מחדל בפרופיל שלך.",
  ai_save_config: "שמור הגדרות AI",
  ai_config_saved: "הגדרות AI נשמרו",
  ai_save_failed: "שמירה נכשלה: ",
  ai_verified: "מאומת",
  ai_default_badge: "ברירת מחדל",

  // ── Plot Panel ──
  plot_cat_main_quest: "משימה ראשית",
  plot_cat_side_quest: "משימת צד",
  plot_cat_plot_hook: "וו עלילה",
  plot_cat_conflict: "עימות",
  plot_cat_key_moment: "רגע מפתח",
  plot_cat_event: "אירוע",
  plot_cat_development: "התפתחות",
  plot_cat_lore: "ידע",
  plot_cat_completion: "השלמה",
  plot_cat_note: "הערה",
  plot_tab_quests: "משימות",
  plot_tab_quests_desc: "משימות ראשיות וצדדיות עם יעדים וקישורי תרחישים.",
  plot_tab_story: "סיפור",
  plot_tab_story_desc: "רגעי מפתח, אירועים, ווי עלילה, עימותים וידע.",
  plot_tab_conditions: "תנאים",
  plot_tab_conditions_desc: "תנאי ניצחון, תבוסה וסיום.",
  plot_relevance_critical: "קריטי",
  plot_relevance_high: "גבוה",
  plot_relevance_medium: "בינוני",
  plot_relevance_low: "נמוך",
  plot_relevance_background: "רקע",
  plot_objectives: "יעדים",
  plot_add_objective: "הוסף יעד...",
  plot_entry_title: "כותרת רשומה...",
  plot_add_entry: "הוסף רשומה",
  plot_no_quests: "אין משימות עדיין",
  plot_no_story: "אין רשומות סיפור עדיין",
  plot_no_conditions: "אין תנאי השלמה עדיין",
  plot_add_first: "הוסף רשומה ראשונה",
  plot_title_placeholder: "כותרת...",
  plot_describe_placeholder: "תאר את אלמנט העלילה הזה...",
  plot_category: "קטגוריה",
  plot_relevance: "רלוונטיות",
  plot_linked_scenario: "תרחיש מקושר",
  plot_none: "ללא",
  plot_no_description: "אין תיאור עדיין",
  plot_all_scenarios: "כל התרחישים",
  plot_aria_filter_scenario: "סינון לפי תרחיש",
  plot_aria_new_entry_category: "קטגוריית רשומה חדשה",
  plot_aria_edit_category: "עריכת קטגוריה",
  plot_aria_linked_scenario: "תרחיש מקושר",
  plot_merge: "מזג",
  plot_selected: "נבחרו",
  plot_select_min_2: "בחר לפחות 2 רשומות למיזוג",
  plot_merge_failed: "המיזוג נכשל",
  plot_deleted: "הרשומה נמחקה",
  plot_delete_failed: "מחיקה נכשלה",
  plot_save_failed: "שמירה נכשלה",
  plot_add_failed: "הוספת רשומה נכשלה",

  // ── Design Issues Panel ──
  di_loading: "טוען משוב עיצובי…",
  di_no_issues: "לא נמצאו בעיות עיצוב",
  di_no_issues_desc: "בעיות נאספות במהלך המשחק ומוצגות כאן לתיקון.",
  di_title: "בעיות עיצוב",
  di_open: "פתוחות",
  di_desc: "בעיות שזוהו במהלך המשחק שדורשות את תשומת לבך בעורך העולם.",
  di_cat_entity: "ישות",
  di_cat_mechanic: "מכניקה",
  di_cat_prompt: "פרומפט",
  di_cat_tool: "כלי",
  di_cat_content: "תוכן",
  di_dismiss: "סגור",
  di_occurrences: "הופעות",
  di_first_seen_turn: "נראה לראשונה: תור",
  di_source_ai: "זוהה ע\"י AI",
  di_source_rule: "זוהה ע\"י חוק",

  // ── Privacy Section (extras) ──
  priv_confidential: "מצב סודי",
  priv_confidential_desc: "הגבל עולם זה למשתמשים מוזמנים בלבד. AI של הפלטפורמה מושבת — רק ספק ה-AI החיצוני שלך ישמש.",
  priv_confidential_active: "מצב סודי פעיל.",
  priv_confidential_active_desc: "עולם זה מוסתר מגילוי ציבורי, מוגבל למוזמנים, ומשתמש רק בספק ה-AI החיצוני שהגדרת (BYOK / Custom AI). שיתוף ציבורי, פרסום ושכפול מושבתים.",
  priv_locked_by_confidential: "נעול במצב סודי",
  priv_share_link: "קישור שיתוף",
  priv_share_link_desc: "שתף קישור זה כדי לאפשר לכל אחד לצפות בעולם ולהתחיל לשחק.",
  priv_share_copied: "קישור שיתוף הועתק!",

  // ── Generation Section (extras) ──
  gen_conservative: "שמרני",
  gen_balanced: "מאוזן",
  gen_aggressive: "אגרסיבי",
  gen_conservative_desc: "יצירה אוטומטית מינימלית. יוצר רק מה שהעולם דורש בהכרח.",
  gen_balanced_desc: "יצירה מתונה. יוצר ישויות וסיפור לפי הצורך.",
  gen_aggressive_desc: "בניית עולם מקסימלית. יוצר ישויות, סיפור ותמונות בשפע.",
  gen_conservative_detail: "ישויות חדשות רק כשמוזכרות במפורש. ללא תמונות סצנה, ללא ידע ספקולטיבי.",
  gen_balanced_detail: "יצירה אוטומטית של NPC-ים ומיקומים באזכור. תמונות סצנה מדי פעם.",
  gen_aggressive_detail: "יצירה יזומה של NPC/מיקום/עלילה. תמונות סצנה אוטומטיות. תחזוקת קודקס אוטומטית.",

  // ── Context Panel ──
  ctx_description: "תיאור",
  ctx_click_to_edit: "לחץ לעריכה",
  ctx_click_to_add: "לחץ להוספת תיאור, או תן ל-AI ליצור אחד.",
  ctx_media_generation: "יצירת מדיה",
  ctx_allow_ingame: "אפשר יצירה במשחק",
  ctx_allow_ingame_desc: "כשמופעל, שחקנים יכולים ליצור דיוקנאות דמויות במהלך המשחק. כשמושבת, יצירת מדיה מוגבלת לבונה העולמות.",
  ctx_media_enabled: "יצירת מדיה במשחק הופעלה",
  ctx_media_disabled: "יצירת מדיה במשחק הושבתה",
  ctx_update_failed: "עדכון ההגדרה נכשל",

  // ── Scenarios Panel ──
  scn_desc: "הגדר תרחישי התחלה — תבניות שמעצבות את תחילת ההרפתקה.",
  scn_new: "תרחיש חדש",
  scn_no_scenarios: "אין תרחישים עדיין.",
  scn_no_scenarios_desc: "צור תרחישים כדי לתת לשחקנים נקודות התחלה מובנות. ללא תרחישים, הרפתקאות מתחילות בצורה חופשית.",
  scn_create_first: "צור תרחיש ראשון",
  scn_needs_title: "תרחיש חייב כותרת",
  scn_updated: "התרחיש עודכן",
  scn_created: "התרחיש נוצר",
  scn_default_set: "תרחיש ברירת מחדל הוגדר",
  scn_deleted: "התרחיש הועבר לפח",
  scn_delete_failed: "מחיקת תרחיש נכשלה",
  scn_difficulty_easy: "קל",
  scn_difficulty_normal: "רגיל",
  scn_difficulty_hard: "קשה",
  scn_difficulty_brutal: "אכזרי",
  scn_difficulty_adaptive: "מסתגל",
  scn_img_saved: "תמונת תרחיש נשמרה",
  scn_img_save_failed: "שמירת התמונה נכשלה",
  scn_img_removed: "תמונת תרחיש הוסרה",
  scn_img_remove_failed: "הסרת התמונה נכשלה",

  // ── About Section (editor) ──
  about_preview_page: "תצוגה מקדימה",
  about_click_change_icon: "לחץ להחלפת אייקון",
  about_click_set: "לחץ להגדרה",
  about_world_name_hint: "שם התצוגה שמוצג לשחקנים ובדף הציבורי.",
  about_world_id_copied: "מזהה העולם הועתק",
  about_anonymous: "אנונימי",

  // ── Actions Section (editor) ──
  act_world_deleted: "העולם נמחק",
  act_delete_failed: "מחיקה נכשלה",
  act_clone_placeholder: "העולם המשוכפל שלי",
  act_clone_failed: "שכפול נכשל",
  act_cloned: "העולם שוכפל בהצלחה!",

  // ── Gameplay panels ──
  play_auto: "אוטו",
  play_manual: "ידני",
  play_no_response: "⚠ לא התקבלה תגובה",
  play_send_again: "שלח שוב",
  play_may_not_received: "⚠ ייתכן שלא התקבל",
  play_you: "אתה",
  play_turn: "תור",
  play_active: "פעיל",
  play_switch: "החלף",
  play_no_pov: "אין דמויות POV רשומות עדיין. המספר יוסיף אותן ככל שהסיפור מתקדם.",
  play_no_party: "אין חברי קבוצה",
  play_party: "קבוצה",
  play_waiting_char: "ממתין ליצירת דמות...",
  play_inner_voice: "קול פנימי",
  play_thoughts_log: "יומן",
  play_observing: "משקיף בשקט…",
  play_awaiting_thoughts: "ממתין למחשבות…",

  // ── Decision Journal ──
  play_decision_journal: "יומן החלטות",
  play_pending_consequences: "תוצאות בהמתנה",
  play_choices_pending: "חלק מהבחירות שלך עדיין לא מומשו במלואן.",
  play_immediate: "מיידי",
  play_ripple_effects: "אפקט גלים",

  // ── Encounter / Events ──
  play_no_events: "אין אירועים עדיין",
  play_no_events_desc: "אירועים, מפגשים וחדשות עולם יופיעו כאן ככל שהסיפור מתפתח.",
  play_events_world: "אירועים ועולם",
  play_active_events: "אירועים פעילים",
  play_pending_ripples: "גלים בהמתנה",

  // ── Lore Codex ──
  play_codex_characters: "דמויות",
  play_codex_locations: "מיקומים",
  play_codex_quests: "משימות ומטרות",
  play_codex_factions: "סיעות וארגונים",
  play_codex_items: "פריטים וחפצים",
  play_codex_lore: "ידע וסיפור",

  // ── Research Panel ──
  play_research_tree: "עץ מחקר",
  play_research_in_progress: "בתהליך",
  play_research_queued: "בתור",
  play_research_completed: "הושלם",
  play_research_none: "לא התחיל מחקר עדיין",
  play_research_ask: "שאל על נושאי מחקר זמינים",

  // ── Operations Panel ──
  play_ops_overview: "סקירה",
  play_ops_territory: "טריטוריה",
  play_ops_workforce: "כוח אדם",
  play_ops_resources: "משאבים",
  play_ops_unnamed_org: "ארגון ללא שם",

  // ── Org tiers/types/styles ──
  play_tier_street: "רמת רחוב",
  play_tier_established: "מבוסס",
  play_tier_major: "שחקן מרכזי",
  play_tier_dominant: "כוח דומיננטי",
  play_tier_undisputed: "כוח בלתי מעורער",
  play_org_criminal: "סינדיקט פשע",
  play_org_intelligence: "תא מודיעין",
  play_org_corporate: "אימפריה תאגידית",
  play_org_military: "פיקוד צבאי",
  play_org_custom: "מותאם אישית",
  play_style_hierarchical: "היררכי",
  play_style_cell: "מבוסס תאים",
  play_style_feudal: "פיאודלי",

  // ── Item rarity ──
  play_rarity_common: "נפוץ",
  play_rarity_uncommon: "לא נפוץ",
  play_rarity_rare: "נדיר",
  play_rarity_epic: "אפי",
  play_rarity_legendary: "אגדי",

  // ── Dice Tray ──
  play_quick_rolls: "הטלות מהירות",
  play_dice_hint: "המספר מכריע קוביות, מודיפיקטורים ו-DC",

  // ── Location detail ──
  play_known_details: "פרטים ידועים",
  play_travel_to: "נסיעה אל",

  // ── Codex extra ──
  play_codex_empty: "הקודקס ריק",
  play_codex_empty_desc: "גילויים יופיעו כאן ככל שתחקרו את העולם — אנשים שתפגשו, מקומות שתבקרו, וידע שתגלו.",
  play_codex_title: "קודקס",
  play_codex_search: "חיפוש בקודקס…",
  play_codex_other: "אחר",

  // ── Encounter extra ──
  play_enc_all: "הכל",
  play_enc_encounters: "מפגשים",
  play_enc_news: "חדשות",
  play_enc_ripples: "גלגולים",
  play_enc_no_encounters: "אין מפגשים עדיין",
  play_enc_no_news: "אין חדשות עולם עדיין",
  play_enc_since_event: "מאז האירוע האחרון",
  play_enc_since_news: "מאז חדשות",

  // ── Research extra ──
  play_research_tier: "דרגה",
  play_research_turn_left: "נותרו",

  // ── Org / Operations shared ──
  play_org_unnamed: "ארגון ללא שם",
  play_org_treasury: "אוצר",
  play_org_income_turn: "הכנסה/תור",
  play_org_tier: "דרגה",
  play_org_morale: "מורל",
  play_org_heat: "חום",
  play_org_territories: "שטחים",
  play_org_personnel: "כוח אדם",
  play_org_resources: "משאבים",
  play_org_no_territory: "אין נתוני שטח עדיין. תפסו מיקומים לבנות את האחוזה.",
  play_org_no_personnel: "לא גויסו כוחות עדיין.",
  play_org_no_resources: "אין משאבים למעקב עדיין. משאבים מופיעים כשהסיפור מציג אותם.",
  play_org_controlled: "נשלט",
  play_org_contested: "במחלוקת",
  play_org_rival_factions: "סיעות יריבות",
  play_org_stockpile: "מלאי",
  play_org_production: "ייצור",
  play_org_upkeep: "אחזקה",
  play_org_controlled_loc: "מיקומים נשלטים",
  play_org_no_territory_ctrl: "אין שטחים נשלטים עדיין",

  // ── Item card ──
  play_item_equipped: "מצויד",
  play_item_modifiers: "שינויים",
  play_item_when_equipped: "(כשמצויד)",
  play_item_effects: "אפקטים",
  play_item_durability: "עמידות",
  play_item_charges: "טעינות",
  play_item_weight: "משקל",
  play_item_cursed: "מקולל",
  play_item_quest: "פריט משימה",

  // ── Recent thoughts ──
  play_recent_thoughts: "מחשבות אחרונות",

  // ── PlayChatInput extra ──
  play_autoscroll_on: "גלילה אוטומטית מופעלת",
  play_autoscroll_off: "גלילה אוטומטית כבויה",
  play_debug_downloads: "הורדות ניפוי",
  play_conversation_log: "יומן שיחה",
  play_game_snapshot: "תצלום משחק",

  // ── Locations Panel (editor) ──
  loc_open_map_editor: "פתח עורך מפות",
  loc_maps: "מפות",
  loc_no_maps: "לא נוצרו מפות עדיין",
  loc_new_map: "מפה חדשה",
  loc_map_editor: "עורך מפות",

  // ── Play widgets ──
  widget_rest_title: "מנוחה והתאוששות",
  widget_rest_hit_dice: "קוביות חיים",
  widget_rest_last_long: "מנוחה ארוכה אחרונה",
  widget_rest_today: "היום",
  widget_rest_days_ago: "ימים",
  widget_rest_short: "מנוחה קצרה",
  widget_rest_long: "מנוחה ארוכה",
  widget_combat_death_saves: "הצלות מוות",
  widget_combat_attack: "התקפה",
  widget_combat_defend: "הגנה",
  widget_combat_flee: "בריחה",
  widget_combat_special: "מיוחד",
  widget_combat_attack_desc: "הכה את היעד שלך",
  widget_combat_defend_desc: "התכונן לפגיעה",
  widget_combat_flee_desc: "נסה לברוח",
  widget_combat_special_desc: "השתמש ביכולת",
  widget_conditions_title: "מצבים",
  widget_conditions_none: "אין מצבים פעילים",
  widget_conditions_exhaustion: "תשישות",
  widget_conditions_concentration: "ריכוז",
  widget_conditions_turns_left: "תורות נותרו",

  // ── About page ──
  about_hero_title_1: "לכל סיפור מגיע",
  about_hero_title_2: "מנוע משחק.",
  about_hero_desc: "Adventure Venture היא פלטפורמת הרפתקאות טקסט מבוססת בינה מלאכותית. אתם בונים עולמות, ה-AI מנהל אותם, והבחירות שלכם באמת משנות — גם הגרועות.",
  about_hero_desc_em: "בעיקר הגרועות.",
  about_hero_cta_dashboard: "ללוח הבקרה",
  about_hero_cta_start: "הצטרף לרשימת ההמתנה",
  about_hero_cta_browse: "גלו עולמות",
  about_bottom_title: "העולם שלכם מחכה.",
  about_bottom_desc: "תבנו משהו אבסורדי. תבנו משהו אפי. תבנו משהו שלא הגיוני בכלל ותראו איך ה-AI מנסה לגרום לזה לעבוד. אנחנו מאמינים בכם. כנראה.",
  about_badge_worldbuilding: "בניית עולמות",
  about_badge_gamemaster: "מנהל משחק AI",
  about_badge_survival: "הישרדות ולחימה",
  about_badge_npcs: "דמויות חיות",
  about_badge_timetravel: "כל ז׳אנר. כל עולם.",
  about_badge_multiplayer: "מרובה משתתפים",
  about_sub_worldbuilding: "הקודקס",
  about_sub_gamemaster: "תזמורת הסיפור",
  about_sub_survival: "מכניקות שנושכות חזרה",
  about_sub_npcs: "מנוע התוצאות",
  about_sub_timetravel: "מרחב אינסופי של אפשרויות",
  about_sub_multiplayer: "כאוס משותף",
  about_title_worldbuilding: "בנו יקומים שלמים.\nמהספה.",
  about_title_gamemaster: "מנהל משחק שלעולם\nלא מבטל ערב משחק.",
  about_title_survival: "תמותו בסטייל.\nשוב ושוב.",
  about_title_npcs: "דמויות שלא שוכחות\nולא סולחות.",
  about_title_timetravel: "דינוזאורים פוגשים\nחיילי חלל.",
  about_title_multiplayer: "תהרסו חברויות.\nיחד.",
  about_desc_worldbuilding_1: "תדמיינו שמישהו נותן לכם טבלה ואומר \"תמלאו, זה יקום.\" בגדול זה מה שעשינו, רק שהטבלה חושבת לבד ועושה את רוב העבודה בשבילכם.",
  about_desc_worldbuilding_2: "תארו את העולם בשפה רגילה — או תעלו מסמכי לור קיימים — ותראו איך ה-AI מאכלס יבשות, סיעות, דמויות עם עבר חשוד, ואת הפונדק שכל עולם פנטזיה חייב על פי חוק.",
  about_desc_worldbuilding_3: "כל ישות שיוצרים מחוברת לכל השאר. שנו את שם המלך — ופתאום למרד צריך שלטים חדשים. הקודקס עוקב אחרי קשרים, היררכיות וטינות כדי שלא תצטרכו.",
  about_desc_gamemaster_1: "מנהל המשחק שלנו הוא פחות רובוט עם תסריט ויותר במאי תיאטרון מטורלל שבמקרה שולט במציאות. הוא מפעיל סוכני AI מרובים — מספר סיפורים, דמויות, שופט קרב, שומר לור — כולם מתווכחים מאחורי הקלעים על מה שצריך לקרות.",
  about_desc_gamemaster_2: "מנהל הקושי מכוונן בשקט את רמת האתגר. מנצחים בקלות? תהנו מהמארב. נמחצים? מעיין הריפוי הנוח הזה תמיד היה פה, ברור.",
  about_desc_gamemaster_3: "מנוע הקצב עוקב אחרי מתח דרמטי כמו תסריטאי של אופרת סבון. רגעים שקטים בונים לשיאים. ניצחונות מרגישים מוצדקים. הפסדים מרגישים דרמטיים. זה לא באג — זה מבנה סיפורי.",
  about_desc_survival_1: "קרב בסגנון D&D עם גלגול קוביות אמיתי, סדר יוזמה, והרגע המופלא שבו מגלגלים 1 טבעי תוך ניסיון להרשים דרקון. מערכת הקרב מנהלת חיים, מצבים, הצלות, והחרדה הקיומית של מחריצי כישוף שנגמרים.",
  about_desc_survival_2: "מכניקות הישרדות עוקבות אחרי רעב, צמא, טמפרטורה ותשישות — כי שום דבר לא אומר \"הרפתקה אפית\" כמו ברבריאן שמצטנן. תייצרו ציוד, תנהלו משאבים, ותתווכחו עם ה-AI על פטריות חשודות.",
  about_desc_survival_3: "מערכת כלכלה שבה זהב באמת חשוב. קנו ציוד, שחדו שומרים, השקיעו בנדל\"ן בממלכה בדיונית. יומן המשימות עוקב אחרי כל מה שהשגתם, מה שנכשלתם בו, ומה שאתם מעמידים פנים שלא קרה.",
  about_desc_npcs_1: "כל דמות מונעת על ידי סוכן AI עצמאי עם זיכרונות, דעות, ויכולת מטרידה לפסיביות-אגרסיביות. גנבתם מחנווני? הוא זוכר. עזרתם לחקלאי? הוא יקרא פרה על שמכם. בגדתם בראש הגילדה? בהצלחה למצוא מי שימכור לכם שיקויים.",
  about_desc_npcs_2: "מערכת המוניטין עוקבת אחרי מה שכל סיעה חושבת עליכם — והם מרכלים. המעמד שלכם בגילדת הגנבים משפיע על איך המשמר מתייחס אליכם, מה שמשפיע על הנחות אצל הסוחרים, מה שמשפיע על הקנייה של החרב שאתם צריכים בשביל משימה של גילדת הגנבים.",
  about_desc_npcs_3: "מערכת המוסר לא שופטת — היא רושמת. הבחירות שלכם מזיזות את הכיוון המוסרי של הדמות דרך מעשים, לא תפריטים. צדיקים מקבלים הערצה. נבלים מפחידים. בעלי מוסר גמיש מוזמנים למסיבות הכי טובות.",
  about_desc_timetravel_1: "פנטזיה מימי הביניים זה נחמד, אבל מה אם האביר שלכם צריך לנהל מו\"מ עם תאגיד סייברפאנק? מה אם הבלש נתקל במעגל פיות? מה אם קברניט החלל התרסק בעולם שרץ על קסם?",
  about_desc_timetravel_2: "למנוע לא אכפת מגבולות ז׳אנר. תבנו מסתורין סטימפאנק ויקטוריאני. תוכנית בישול פוסט-אפוקליפטית. מותחן פוליטי בפרלמנט גמדי. פאן פיקשן עם דיוק לור שיגרום ליוצרים המקוריים לחרוק שיניים.",
  about_desc_timetravel_3: "העלו חומרי מקור — רומנים, ויקי, מדריכים — והמערכת סופגת הכל לקודקס. הלור שלכם הופך ללור של ה-AI. הוא יתייחס לפרט אובסקורי מעמוד 47 כאילו באמת קרא את הספר. כי הוא קרא.",
  about_desc_multiplayer_1: "תזמינו חברים ותראו איך השוד המתוכנן בקפידה מתפרק כי מישהו החליט ללטף את כלב השמירה. מולטיפלייר תומך בתורות, כאוס חופשי, וקרב לפי יוזמה — כי לחלק מהוויכוחים צריך מסגרת.",
  about_desc_multiplayer_2: "כל שחקן מקבל גיליון דמות, מלאי, ורשימה הולכת וגדלה של החלטות מפוקפקות. ה-AI עוקב אחרי המוניטין של כולם, התקדמות משימות, ואותו שחקן שמנסה לפלרטט עם כל דמות ללא יוצא מן הכלל.",
  about_desc_multiplayer_3: "שתפו עולמות עם שותפים שיעזרו לבנות את הלור, או פרסמו לקהילה. מסתורין הרצח הויקטוריאני שלכם יכול להפוך לקומדיה של מישהו אחר. זה היופי של כאוס — הוא שיתופי.",

  // ── BYOK section keys ──
  about_badge_byok: "המפתח שלך",
  about_sub_byok: "המפתחות שלך, הכללים שלך",
  about_title_byok: "משחק ללא הגבלה.\nעם המפתחות שלך.",
  about_desc_byok_1: "יש לכם מפתח Google Gemini? חשבון ElevenLabs? חברו אותם ותפסיקו לראות את הקרדיטים שלכם נשחקים.",
  about_desc_byok_2: "יצירת טקסט, סינתזת קול, חיפוש — הביאו מפתח משלכם ותשלמו ישירות. חיפושי Wiki ו-Fandom עדיין עולים קרדיטים.",
  about_desc_byok_3: "משתמשי BYOK יכולים גם לבחור מודל AI לכל סוכן — רוצים שהנבל ירוץ על Pro והחנווני על Flash Lite? המפתח שלכם, ההחלטה שלכם.",

  // ── About FAQ section ──
  about_faq_title: "שאלות נפוצות",
  about_faq_q1: "מה מבדיל את Adventure Venture מ-AI Dungeon?",
  about_faq_a1: "ההבדל העיקרי הוא ארכיטקטורלי: Adventure Venture מריצה מספר סוכני AI בו-זמנית — מספר, סוכני NPC בודדים, שופט קרב ושומר לור — במקום צ׳אטבוט יחיד שמשחק את כולם. ל-NPC יש זיכרון מתמשך בין סשנים (לא רק בתוך שיחה אחת), ויש מכניקות משחק אמיתיות: גלגולי קוביות, מערכות הישרדות, כלכלה ושליטה בשטח. AI Dungeon יוצר סיפורים; Adventure Venture מריצה מנוע משחק.",
  about_faq_q2: "האם NPC עם AI באמת זוכרים דברים בין סשנים?",
  about_faq_a2: "כן — זהו הפיצ׳ר שהפתיע את שחקני הבטא ביותר. כל NPC מאחסן זיכרונות מהאינטראקציות שלכם במסד נתונים מתמשך. הם זוכרים את ההבטחה שהפרתם, את הטובה שעשיתם, את הברית שנכנסתם אליה במקרה. חזרו שלושה שבועות אחר כך ובעלת הפונדק עדיין יודעת שלא שילמתם את החשבון. רוב פלטפורמות ה-AI RPG מאפסות בין סשנים; Adventure Venture לא.",
  about_faq_q3: "מה זו תמחור BYOK ב-AI RPG?",
  about_faq_a3: "BYOK פירושו Bring Your Own Key — הביאו את המפתח שלכם. במקום ש-Adventure Venture תרכוש כוח AI ותסמן מחיר, אתם מחברים את מפתח ה-API שלכם מ-OpenAI, Google Gemini, או Anthropic Claude ישירות. אתם משלמים לספק ה-AI שלכם בתעריפים הרגילים — אין צורך במנוי ל-Adventure Venture עבור משתמשי BYOK. עבור שחקנים קבועים, זה לרוב זול משמעותית יותר מכל מנוי פלטפורמה.",
  about_faq_q4: "אפשר לשחק ב-Adventure Venture עם חברים?",
  about_faq_a4: "כן. Adventure Venture תומכת במולטיפלייר בזמן אמת — הזמינו חברים לאותו עולם והתרפקו יחד עם מנהל משחק AI משותף שעוקב אחר ההיסטוריה, המלאי והמוניטין של כולם בנפרד. זו אחת מפלטפורמות ה-AI RPG הבודדות שיכולות להחליף מנהל משחק אנושי לקבוצה שלמה.",
  about_faq_q5: "איך מצטרפים לבטא הסגורה?",
  about_faq_a5: "צרו חשבון חינמי והצטרפו לרשימת ההמתנה — אנחנו בוחנים בקשות ושולחים הזמנות כשיש מקום. תומכים מוקדמים יסומנו לצמיתות כמייסדים בקהילת השחקנים.",
  about_faq_q6: "האם Adventure Venture חינמית?",
  about_faq_a6: "Adventure Venture מציעה תוכנית חינמית לחקר הפלטפורמה וקמפיינים קצרים. מצב BYOK מלא — שבו אתם מספקים את מפתחות ה-API שלכם — עולה לרוב פחות ממנוי פלטפורמה עבור שחקנים קבועים, מכיוון שאתם משלמים לספק ה-AI שלכם בתעריפים רגילים ללא סימון מחיר.",

  explore_byok_title: "הביאו מפתח משלכם",
  explore_byok_desc: "השתמשו במפתחות API שלכם לטקסט, קול וחיפוש — ותהנו ממשחק ללא הגבלה בתשלום חודשי קבוע.",
  explore_byok_cta: "למידע נוסף",
  explore_byok_feature_1: "יצירת טקסט ללא הגבלה עם מפתח Gemini",
  explore_byok_feature_2: "קולות ElevenLabs ו-Inworld משלכם",
  explore_byok_feature_3: "בחירת מודל AI לכל סוכן",
  explore_byok_feature_4: "חיפוש SERP עם המפתח שלכם",
  pricing_byok_title: "הביאו מפתח משלכם",
  pricing_byok_desc: "למשתמשים מתקדמים שרוצים שליטה מלאה.",
  pricing_byok_price: "$20",
  pricing_byok_per_month: "/חודש",
  pricing_byok_feature_1: "יצירת טקסט ללא הגבלה (מפתח Gemini שלכם)",
  pricing_byok_feature_2: "TTS ללא הגבלה (ElevenLabs / Inworld שלכם)",
  pricing_byok_feature_3: "חיפוש SERP ללא הגבלה (מפתח שלכם)",
  pricing_byok_feature_4: "בחירת מודל לכל סוכן (מתקדם)",
  pricing_byok_feature_5: "Wiki ו-Fandom עדיין משתמשים בקרדיטים",
  pricing_byok_note: "אתם מספקים מפתחות API. רק חיפושי Wiki ו-Fandom נספרים.",
  pricing_byok_cta: "התחילו",

  // ── Explore page ──
  explore_hero_title_1: "בנה",
  explore_hero_title_2: "כל משחק",
  explore_hero_desc: "מנוע משחק טקסטואלי מונע AI. צור RPGs, משחקי אסטרטגיה, סימולטורים — או משהו חדש לגמרי. בנה את העולם, ה-AI מריץ אותו.",
  explore_cta_start: "הצטרף לרשימת ההמתנה",
  explore_cta_dashboard: "ללוח הבקרה",
  explore_cta_browse: "גלה עולמות",
  explore_how_compare: "איך אנחנו בהשוואה",
  explore_how_compare_desc: "רוב כלי הרפתקאות הטקסט מציעים סיפור בסיסי. אנחנו בנינו מנוע משחק מלא.",
  explore_feature: "תכונה",
  explore_show_more: "תכונות נוספות",
  explore_show_less: "הצג פחות",
  explore_comparison_note: "השוואה מבוססת על תכונות זמינות לציבור נכון למרץ 2026. \"חלקי\" משמעו מימוש מוגבל או בסיסי.",
  explore_what_create: "מה תיצור?",
  explore_what_create_desc: "מאימפריות פשע ועד פאן פיקשן — הנה טעימה ממה שאפשרי.",
  explore_mechanics_title: "מכניקות משחק",
  explore_mechanics_desc: "שלב ותערבב מערכות אלה ליצירת כל ז׳אנר. כל מכניקה היא אבן בניין — שלב אותן למשחק ייחודי.",
  explore_alpha_title: "בטא סגורה — הגעת מוקדם.",
  explore_alpha_desc: "אתה מקבל גישה ל-Adventure Venture בזמן שאנחנו עדיין בונים אותו — פיצ׳רים יוצאים מדי שבוע, וחברי המייסדים משפיעים ישירות על מה שנבנה. המשוב שלך על מה שעובד, מה חסר ומה שבור משנה ממש. חברי הבטא המוקדמים יסומנו לצמיתות כמייסדים.",
  explore_ready_title: "מוכן לבנות את העולם שלך?",
  explore_ready_desc: "ללא צורך בקוד. תאר את העולם, הגדר מכניקות, ותן ל-AI להחיות אותו. שחק לבד או הזמן חברים.",
  explore_get_started: "הצטרף לרשימת ההמתנה",

  // ── Roadmap page ──
  roadmap_badge: "מפת דרכים",
  roadmap_title: "לאן אנחנו הולכים",
  roadmap_desc: "מבניית עולמות ועד טירוף מרובה משתתפים — הנה כל מה ששחררנו, מה מתבשל, ומה באופק.",
  roadmap_features: "תכונות",
  roadmap_cta_title: "יש לך בקשת תכונה?",
  roadmap_cta_desc: "אנחנו בונים מה שהקהילה רוצה. שתף את הרעיונות שלך בפורומים והצביע מה ייצא הבא.",
  roadmap_cta_forums: "בקר בפורומים",
  roadmap_cta_explore: "גלה עולמות",
  roadmap_status_live: "פעיל",
  roadmap_status_beta: "בטא",
  roadmap_status_alpha: "אלפא",
  roadmap_status_planned: "מתוכנן",
  roadmap_status_exploring: "בחקירה",
  roadmap_item_world_builder: "סוכן בניית עולמות AI",
  roadmap_item_world_builder_desc: "עוזר AI שיחתי שיוצר עולמות שלמים — דמויות, מיקומים, סיעות, עלילות ומכניקות — מתיאורים בשפה טבעית.",
  roadmap_item_mechanics: "30+ מכניקות משחק",
  roadmap_item_mechanics_desc: "קרב, מלאי, כלכלה, מוניטין, מוסר, הישרדות, קסם, שליטה בטריטוריה, ארגונים ועוד — הכל ניתן להפעלה לכל עולם.",
  roadmap_item_narrator: "מספר AI ומנוע סיפור",
  roadmap_item_narrator_desc: "תזמורת סיפור רב-סוכנית עם מנהל קושי, מנוע השלכות ומנגנון קצב מפגשים לנרטיבים דינמיים.",
  roadmap_item_image_gen: "יצירת תמונות AI",
  roadmap_item_image_gen_desc: "צרו דיוקנאות דמויות, אמנות סצנות ותמונות מיקומים עם חיפוש הפניות, סגנונות וקודקס.",
  roadmap_item_tts: "הקראת טקסט לדיבור",
  roadmap_item_tts_desc: "שחקני קול מרובים עם קולות מותאמים לכל דמות. הקראת שמע סוחפת לכל סצנה.",
  roadmap_item_document: "העלאת מסמכים וניתוח",
  roadmap_item_document_desc: "העלו קבצי .txt, .md, .json לזרוע עולמות. חילוץ קודקס רב-שלבי, אינדוקס RAG ויצירת ישויות.",
  roadmap_item_journal: "יומן וייצוא סיפור",
  roadmap_item_journal_desc: "צרו רשומות יומן ונרטיבים פרוזאיים מההרפתקה שלכם. ייצוא כקבצי Markdown.",
  roadmap_item_npc_agents: "דמויות רב-סוכניות",
  roadmap_item_npc_agents_desc: "לכל דמות אישיות, זיכרונות, ידע ומצב רגשי משלה. הן זוכרות מה עשיתם ומגיבות בהתאם.",
  roadmap_item_quest_journal: "יומן משימות ומעקב",
  roadmap_item_quest_journal_desc: "גילוי משימות דינמי, קבלה, התקדמות והשלמה. משימות ראשיות, צדדיות וסמויות.",
  roadmap_item_fan_fiction: "כלי מחקר מקוון",
  roadmap_item_fan_fiction_desc: "ייבוא חומר ייחוס מהרשת — ה-AI סופג לור, עובדות וחוקי עולם מ-Google, ויקיפדיה ו-Fandom להעשרת הסיפורים.",
  roadmap_item_custom_rules: "מנוע חוקים מותאם",
  roadmap_item_custom_rules_desc: "הגדירו חוקי משחק בטקסט חופשי. ה-AI אוכף אותם לצד מכניקות מובנות.",
  roadmap_item_forums: "פורומים והודעות ישירות",
  roadmap_item_forums_desc: "שתפו עולמות, דונו באסטרטגיות ושוחחו עם שחקנים. מערכת חברים עם הודעות פרטיות.",
  roadmap_item_research: "מודול מחקר",
  roadmap_item_research_desc: "חיפוש Google, ויקיפדיה ו-Fandom מובנים. ייבוא אוטומטי של קטעי לור, תמונות הפניה ועובדות קאנוניות.",
  roadmap_item_multiplayer: "שיתוף פעולה מולטיפלייר",
  roadmap_item_multiplayer_desc: "שחקו עם חברים בהרפתקאות משותפות. תורות סיבוביות, יוזמה או חופשי — עם ניהול קבוצה ומשימות משותפות.",
  roadmap_item_world_map: "מפת עולם אינטראקטיבית",
  roadmap_item_world_map_desc: "עורך מפה חזותי עם נקודות, תת-מפות, שכבות וקישור מיקומים. ניווט מרחבי במשחק.",
  roadmap_item_map_library: "ספריית תמונות מפה",
  roadmap_item_map_library_desc: "העלו תמונות מפה, צרו SVG ותצוגות מפה מרובות סגנונות.",
  roadmap_item_byoai: "הבא AI משלך (18+)",
  roadmap_item_byoai_desc: "חברו מפתח Gemini API משלכם לחוויות ללא צנזורה. חופש יצירתי מלא.",
  roadmap_item_music: "מערכת מוזיקה ואווירה",
  roadmap_item_music_desc: "העלו רצועות אווירה, שייכו לסצנות. מוזיקת רקע שמתאימה למצב הרוח.",
  roadmap_item_mobile: "אפליקציה לנייד",
  roadmap_item_mobile_desc: "חוויה ניידת למשחק בדרכים. ממשק מגע, התראות ופנים לא-מקוונות.",
  roadmap_item_marketplace: "שוק עולמות",
  roadmap_item_marketplace_desc: "מכרו עולמות ותרחישים. הגדירו מחירים, שכפולים או הציעו מהדורות חינמיות.",
  roadmap_item_voice_chat: "צ׳אט קולי עם מנהל משחק AI",
  roadmap_item_voice_chat_desc: "שיחות קוליות בזמן אמת עם המספר. דברו את הפעולות ושמעו את הסיפור מתגלה.",
  roadmap_item_campaign: "מצב קמפיין",
  roadmap_item_campaign_desc: "קמפיינים רב-מושביים עם שמירה מתמשכת, התקדמות בפרקים וקשתות נרטיביות מסתעפות.",
  roadmap_item_pdf_export: "ייצוא PDF וספר אלקטרוני",
  roadmap_item_pdf_export_desc: "ייצוא ההרפתקה כספר PDF מעוצב — עם חלוקה לפרקים, אמנות דמויות ומפות.",
  roadmap_item_streaming: "אינטגרציית סטרימינג",
  roadmap_item_streaming_desc: "שכבות OBS, אינטגרציית צ׳אט Twitch והצבעות קהל לשידורי סיפור שיתופיים.",
  roadmap_item_video: "קטעי וידאו מונפשים ב-AI",
  roadmap_item_video_desc: "קליפים קצרים שנוצרו ב-AI לרגעי סיפור מפתח — חשיפות בוסים, מוות דרמטי, ניצחונות אפיים.",
  roadmap_item_vr: "אינטגרציית VR",
  roadmap_item_vr_desc: "היכנסו לעולם שלכם. רינדור טקסט מוכן ל-VR, שמע מרחבי וחקירת מפה סוחפת.",
  roadmap_item_procgen: "יצירת עולם פרוצדורלית",
  roadmap_item_procgen_desc: "יצירת עולם שלם בלחיצה אחת עם גיאוגרפיה, פוליטיקה, היסטוריה ומאות דמויות מחוברות.",

  // ── Support Us / Pricing page ──
  support_badge: "תמוך בפרויקט",
  support_title: "תדלק את ההרפתקאות",
  support_desc: "קרדיטים מפעילים הכל — בניית עולמות, הקראת AI, יצירת תמונות וקול. כל חבילה גם מעניקה XP וכותרת בלעדית.",
  support_best_value: "⭐ שווי הכי טוב",
  support_get_pack: "קבל",
  support_what_buy: "מה קונים בקרדיטים?",
  support_ai_narration: "הקראת AI",
  support_ai_narration_desc: "כל הודעה עולה ~0.01–0.04 קרדיטים",
  support_world_building: "בניית עולמות",
  support_world_building_desc: "הוספת ישויות, מכניקות, נקודות עלילה",
  support_image_voice: "תמונה וקול",
  support_image_voice_desc: "יצירת אמנות AI והמרת טקסט לדיבור",
  support_xp_title: "XP וכותרות",
  support_xp_desc: "כל חבילת התחלה מעניקה XP בונוס וכותרת בלעדית המוצגת בפרופיל שלך ובקהילה. XP גבוה יותר גם פותח גישה לעולמות פרימיום.",
  support_title_label: "כותרת",
  support_lifetime_badge: "קרדיטים תקפים לכל החיים — ללא תפוגה, ללא מנוי",
  support_free: "חינם",
  support_pack_trial: "חבילת ניסיון",
  support_pack_trial_desc: "צעד ראשון — מספיק ליצור עולם ראשון ולהריץ הרפתקה קצרה",
  support_pack_starter: "חבילת התחלה",
  support_pack_starter_desc: "בנה את העולם הראשון שלך והפעל כמה הרפתקאות עם הקראת AI",
  support_pack_adventurer: "חבילת הרפתקן",
  support_pack_adventurer_desc: "בנה עולמות עשירים, הפעל הרפתקאות מרובות וצור עשרות תמונות",
  support_pack_hero: "חבילת גיבור",
  support_pack_hero_desc: "שחרר את הפוטנציאל המלא — עולמות ענקיים, הקראת AI ללא הגבלה, משחק קולי ויצירת אמנות פרימיום",
  support_pack_legend: "חבילת אגדה",
  support_pack_legend_desc: "למסורים באמת — בנה אימפריה של עולמות, שתף עם חברים והפוך לאגדה מייסדת של הפלטפורמה",

  // ── Contact page ──
  contact_badge: "צור קשר",
  contact_title: "צור קשר",
  contact_desc: "יש לך שאלה, הצעה, או סתם רוצה לומר שלום? נשמח לשמוע ממך.",
  contact_send_message: "שלח הודעה",
  contact_respond_time: "אנחנו בדרך כלל עונים תוך 24 שעות.",
  contact_name: "שם",
  contact_name_placeholder: "השם שלך",
  contact_email: "דוא״ל",
  contact_email_placeholder: "your@email.com",
  contact_subject: "נושא",
  contact_subject_placeholder: "על מה מדובר?",
  contact_message: "הודעה",
  contact_message_placeholder: "ספר לנו מה בראש שלך...",
  contact_send: "שלח הודעה",
  contact_github: "GitHub",
  contact_github_desc: "דווח על באגים ובקש תכונות",
  contact_community: "קהילה",
  contact_community_desc: "הצטרף לדיון בפורומים שלנו",
  contact_support_cta: "רוצה לתמוך בפרויקט?",
  contact_support_cta_desc: "בדוק את חבילות ההתחלה לקבלת קרדיטים וכותרות בלעדיות!",
  contact_fill_required: "אנא מלא את כל השדות הנדרשים",
  contact_sent_success: "ההודעה נשלחה! נחזור אליך בקרוב.",
  contact_sent_error: "שליחת ההודעה נכשלה. אנא נסה שוב.",

  // ── Community page ──
  community_forums: "פורומים",
  community_loading: "טוען פורומים...",
  forum_title: "פורומים קהילתיים",
  forum_col_forum: "פורום",
  forum_col_topics: "נושאים",
  forum_col_posts: "פוסטים",
  forum_col_last_post: "פוסט אחרון",
  forum_no_categories: "אין קטגוריות פורום עדיין.",
  forum_no_posts_yet: "אין פוסטים עדיין",
  forum_stats_title: "סטטיסטיקת פורום",
  forum_total_topics: "סה״כ נושאים",
  forum_total_posts: "סה״כ פוסטים",
  forum_total_members: "סה״כ חברים",
  forum_newest_member: "חבר חדש",
  forum_by: "מאת",
  forum_start_new_topic: "נושא חדש",
  forum_create_topic_title: "יצירת נושא חדש",
  forum_topic_title_placeholder: "כותרת הנושא...",
  forum_first_post_placeholder: "כתוב את הפוסט הראשון שלך...",
  forum_post_anonymously: "פרסם באנונימיות",
  forum_create_topic: "צור נושא",
  forum_no_topics: "אין נושאים עדיין.",
  forum_no_topics_desc: "היה הראשון להתחיל דיון!",
  forum_col_topic: "נושא",
  forum_col_replies: "תגובות",
  forum_col_views: "צפיות",
  forum_pinned_topics: "נושאים נעוצים",
  forum_topics: "נושאים",
  forum_posts_count: "פוסטים",
  forum_views_count: "צפיות",
  forum_locked: "נעול",
  forum_topic_not_found: "הנושא לא נמצא.",
  forum_edited: "(נערך)",
  forum_unpin: "בטל נעיצה",
  forum_pin: "נעץ נושא",
  forum_unlock: "בטל נעילה",
  forum_lock: "נעל נושא",
  forum_save: "שמור",
  forum_cancel: "ביטול",
  forum_quote: "ציטוט",
  forum_reply_placeholder: "כתוב תגובה...",
  forum_post_reply: "שלח תגובה",
  forum_topic_locked: "נושא זה נעול ואינו מקבל תגובות נוספות.",
  forum_joined: "הצטרף",
  forum_member_veteran: "ותיק",
  forum_member_regular: "קבוע",
  forum_member_active: "פעיל",
  forum_member_member: "חבר",
  forum_member_newcomer: "חדש",
  forum_time_just_now: "עכשיו",
  forum_time_minutes_ago: "ד׳ לפני",
  forum_time_hours_ago: "ש׳ לפני",
  forum_time_days_ago: "י׳ לפני",
  forum_post_updated: "הפוסט עודכן!",
  forum_update_failed: "העדכון נכשל: {error}",
  forum_action_failed: "הפעולה נכשלה: {error}",
  forum_react_failed: "התגובה נכשלה",

  // ── Not Found page ──
  notfound_title: "404",
  notfound_desc: "אופס! הדף לא נמצא",
  notfound_back: "חזרה לדף הבית",

  // ── Gameplay UI ──
  play_anonymous: "אנונימי",
  play_you_suffix: "(את/ה)",
  play_turn_label: "תור",
  play_invite_copied: "קישור ההזמנה הועתק!",
  play_present: "נוכחים",
  play_scene_tags: "תגיות סצנה",
  play_day: "יום",
  play_time: "שעה",
  play_mode: "מצב",
  play_combat: "קרב",
  play_phase: "שלב",
  play_initiative_order: "סדר יוזמה",
  play_player_character: "דמות שחקן",
  play_hp: "חיים",
  play_level: "רמה",
  play_gold: "זהב",
  play_no_character: "אין נתוני דמות עדיין",
  play_character: "דמות",
  play_world: "עולם",
  play_journal: "יומן",
  play_director: "במאי",
  play_party_chat: "צ׳אט קבוצה",
  play_no_messages: "אין הודעות עדיין. תגיד שלום לקבוצה!",
  play_message_party: "כתוב לקבוצה...",
  play_send_failed: "שליחת ההודעה נכשלה",
  play_portrait: "דיוקן",
  play_conditions: "מצבים",
  play_inventory_empty: "המלאי ריק",
  play_weight: "משקל",
  play_encumbered: "עמוס",
  play_heavy_load: "עומס כבד",
  play_overburdened: "עומס יתר",
  play_base: "בסיס",
  play_active_bonuses: "בונוסים פעילים",
  play_equipped: "מצויד",
  play_available: "זמין",
  play_complete: "הושלם",
  play_failed: "נכשל",
  play_create_quest: "צור משימה",
  play_quest_goal: "תאר את מטרת המשימה...",
  play_go: "קדימה",
  play_no_quests: "אין משימות {tab}",
  play_accept: "קבל",
  play_rewards: "תגמולים",
  play_personal: "אישי",
  play_diary: "יומן",
  play_story: "סיפור",
  play_no_adventure: "לא נטענה הרפתקה",
  play_no_entries: "אין רשומות עדיין",
  play_write_hint: "כתוב רשומת יומן או צור סיפור",
  play_story_caught_up: "הסיפור עדכני — שחק עוד או כתוב מחדש.",
  play_story_style_placeholder: "לדוגמה: השתמש במשפטים קצרים. הימנע משפה פרחונית. כבד בדיאלוג.",
  play_action_details: "פרטים...",
  play_critical: "!קריטי",
  play_fumble: "!כישלון",
  play_lore_codex: "קודקס ידע",
  play_search_lore: "חפש ידע…",
  play_edit_world: "ערוך עולם",
  play_edit_template: "ערוך תבנית",
  play_edit_game: "ערוך משחק",
  play_editing_game_banner: "עריכת מופע משחק",
  play_editing_game_subtitle: "שינויים משפיעים רק על משחק זה, לא על התבנית",
  play_mode_editor: "עורך",
  play_mode_play: "משחק",
  play_mode_switch_aria: "החלף בין עורך למשחק",
  play_multiplayer: "מרובה משתתפים",
  play_your_turn_badge: "🎯 התור שלך",
  play_other_turn: "⏳ התור של {name}",
  play_waiting_other: "ממתין לתור של שחקן אחר...",
  play_hidden_messages: "{count} הודעות מוסתרות",
  play_reclassify_fail: "סיווג מחדש נכשל",
  play_reclassify_success: "סווג מחדש כ-{label}",
  play_continue_story: "המשך סיפור",
  play_rewrite_all: "כתוב הכל מחדש",
  play_chapter: "פרק",
  play_entry: "רשומה",
  play_new_story: "סיפור חדש",
  play_journal_entry: "רשומת יומן",
  play_read_full: "קרא מלא",
  play_no_data: "אין נתוני {label}",

  // ── Multiplayer Communication ──
  mp_tab_chat: "צ׳אט",
  mp_tab_board: "לוח מודעות",
  mp_tab_interactions: "אינטראקציות",
  mp_board_title: "לוח ההרפתקה",
  mp_no_threads: "אין שרשורים עדיין — התחל אחד!",
  mp_new_thread: "שרשור חדש",
  mp_thread_title: "כותרת השרשור…",
  mp_write_post: "כתוב את הפוסט שלך…",
  mp_create_thread: "צור שרשור",
  mp_reply_placeholder: "כתוב תגובה…",
  mp_interactions_title: "אינטראקציות בין שחקנים",
  mp_no_interactions: "אין אינטראקציות עדיין",
  mp_new_interaction: "אינטראקציה חדשה",
  mp_trade: "הצעת מסחר",
  mp_gift: "מתנה",
  mp_challenge: "אתגר",
  mp_alliance: "בקשת ברית",
  mp_select_player: "בחר שחקן…",
  mp_offered_items: "פריטים להציע (מופרדים בפסיקים)",
  mp_requested_items: "פריטים לבקש (מופרדים בפסיקים)",
  mp_offered_gold: "זהב מוצע",
  mp_requested_gold: "זהב מבוקש",
  mp_interaction_message: "הוסף הודעה…",
  mp_offering: "מציע",
  mp_requesting: "מבקש",
  mp_decline: "דחה",
  mp_not_enough_gold: "אין מספיק זהב",
  mp_leave_adventure: "עזוב הרפתקה",
  mp_leave_failed: "עזיבת ההרפתקה נכשלה",
  mp_left_adventure: "עזבת את ההרפתקה",
  mp_kick_failed: "הסרת שחקן נכשלה",
  mp_player_kicked: "השחקן הוסר",
  mp_kick_confirm: "האם אתה בטוח שברצונך להסיר שחקן זה?",
  mp_kick: "הסר",
  mp_spectator: "צופה",
  mp_you_badge: "אתה",
  mp_host_badge: "מנחה",
  mp_anonymous_player: "אנונימי",
  mp_your_char_name: "שם הדמות שלך",
  mp_waiting_for_host: "ממתין למנחה להתחיל את ההרפתקה...",
  mp_invite_code_copied: "קוד הזמנה הועתק!",
  mp_invite_link_copied: "קישור הזמנה הועתק!",
  mp_share_invite_code: "שתף את קוד ההזמנה:",
  mp_share_invite_link: "שתף קישור זה כדי להזמין שחקנים:",
  mp_turn_free_form: "חופשי",
  mp_turn_concurrent: "במקביל",
  mp_turn_initiative: "סדר יוזמה",
  mp_turn_round_robin: "רוטציה",

  // ── Builder: General Panel (About) ──
  wb_gen_about: "אודות",
  wb_gen_about_desc: "זהות, מראה ומידע",
  wb_gen_featured_image: "תמונה ראשית",
  wb_gen_change_banner: "שנה באנר",
  wb_gen_generate_banner: "לחץ ליצירת תמונת באנר",
  wb_gen_icon: "אייקון",
  wb_gen_world_name: "שם העולם",
  wb_gen_world_name_placeholder: "העולם שלי",
  wb_gen_description: "תיאור",
  wb_gen_description_placeholder: "סקירה קצרה של העולם שלך — מה מייחד אותו?",
  wb_gen_promo_title: "מחולל טקסט שיווקי",
  wb_gen_promo_desc: "צור טקסט שיווקי אוטומטי מהתרחישים, הדמויות והמשימות שלך.",
  wb_gen_promo_generate: "צור",
  wb_gen_promo_regenerate: "צור מחדש",
  wb_gen_promo_seed: "טקסט בסיס",
  wb_gen_promo_seed_placeholder: "ספק נקודת התחלה או נקודות מפתח לכלול...",
  wb_gen_promo_style: "סגנון",
  wb_gen_promo_length: "אורך",
  wb_gen_promo_style_professional: "מקצועי",
  wb_gen_promo_style_epic: "אפי",
  wb_gen_promo_style_mysterious: "מסתורי",
  wb_gen_promo_style_casual: "יומיומי",
  wb_gen_promo_length_short: "קצר (1-2 שורות)",
  wb_gen_promo_length_medium: "בינוני (1-2 פסקאות)",
  wb_gen_promo_length_long: "ארוך (3-6 פסקאות)",
  wb_gen_promo_analyzing: "מנתח תרחישים, דמויות ומשימות…",
  wb_gen_promo_copy: "העתק",
  wb_gen_promo_use_desc: "השתמש כתיאור",
  wb_gen_genre_themes: "ז׳אנר ונושאים",
  wb_gen_auto_detect: "זיהוי אוטומטי",
  wb_gen_genre: "ז׳אנר",
  wb_gen_genre_placeholder: "למשל פנטזיה אפלה, מדע בדיוני, סטימפאנק",
  wb_gen_themes: "נושאים",
  wb_gen_themes_placeholder: "למשל גאולה, מאבקי כוח, הישרדות",
  wb_gen_content_language: "שפת תוכן",
  wb_gen_content_language_desc: "כל התוכן שנוצר על ידי AI (ישויות, עלילות, קודקס, סיפור) ייכתב בשפה זו.",
  wb_gen_tags: "תגיות",
  wb_gen_add_tag: "הוסף תגית...",
  wb_gen_add: "הוסף",
  wb_gen_translations: "תרגומים",
  wb_gen_translate_now: "תרגם עכשיו",
  wb_gen_auto_translate: "תרגום אוטומטי בשמירה",
  wb_gen_auto_translate_desc: "תרגם אוטומטית שם, תיאור ותגיות בעת שמירת שינויים",
  wb_gen_primary_language: "שפה ראשית",
  wb_gen_info: "מידע",
  wb_gen_world_id: "מזהה העולם",
  wb_gen_created_by: "נוצר על ידי",
  wb_gen_created: "נוצר",
  wb_gen_saving: "שומר…",
  wb_gen_save_changes: "שמור שינויים",
  wb_gen_saved: "נשמר",
  wb_gen_name_label: "שם",

  // ── Builder: General Panel (Generation) ──
  wb_gen_world_generation: "יצירת עולם",
  wb_gen_world_generation_desc: "שולט בעוצמת יצירת התוכן האוטומטית",
  wb_gen_level_conservative: "שמרני",
  wb_gen_level_balanced: "מאוזן",
  wb_gen_level_aggressive: "אגרסיבי",
  wb_gen_level_active: "פעיל",
  wb_gen_auditor: "מבקר רציפות",
  wb_gen_auditor_desc: "סוכן AI שסוקר מעת לעת את הסיפור לאיתור חוסר עקביות, חורי עלילה והפרות גבולות — ומתקן אוטומטית.",
  wb_gen_enable_auditor: "הפעל מבקר",
  wb_gen_auditor_runs: "רץ כל N תורות לאימות קוהרנטיות נרטיבית",
  wb_gen_audit_interval: "מרווח ביקורת (תורות)",
  wb_gen_audit_frequent: "5 (תכוף)",
  wb_gen_audit_rare: "30 (נדיר)",

  // ── Builder: General Panel (Privacy) ──
  wb_gen_privacy: "פרטיות ושיתוף",
  wb_gen_privacy_desc: "שלוט מי יכול לראות ולגשת לעולם שלך",
  wb_gen_under_dev: "בפיתוח",
  wb_gen_under_dev_desc: "שחקנים יראו הודעת עבודה בתהליך.",
  wb_gen_public_world: "עולם ציבורי",
  wb_gen_public_world_desc: "כל אחד יכול לגלות ולצפות בעולם זה",
  wb_gen_invite_only: "בהזמנה בלבד",
  wb_gen_invite_only_desc: "שחקנים צריכים הזמנה כדי להצטרף",
  wb_gen_allow_cloning: "אפשר שכפול",
  wb_gen_allow_cloning_desc: "אחרים יכולים לשכפל את העולם הזה כתבנית",
  wb_gen_pricing: "תמחור וקרדיטים",
  wb_gen_pricing_desc: "הגדר עלויות לשחקנים לשחק או לשכפל את העולם שלך. הגדר 0 לחינם.",
  wb_gen_ticket_cost: "עלות כרטיס (לסשן)",
  wb_gen_ticket_cost_desc: "קרדיטים שנגבים להתחלת הרפתקה חדשה",
  wb_gen_clone_price: "מחיר שכפול",
  wb_gen_clone_price_desc: "קרדיטים שנגבים לשכפול העולם",
  wb_gen_min_xp: "נ.נ. מינימלי נדרש",
  wb_gen_min_xp_desc: "שחקנים צריכים כמות זו של XP כדי לגשת לעולם (0 = ללא הגבלה)",
  wb_gen_free_for_players: "חינם לשחקנים",
  wb_gen_free_for_players_desc: "אתה סופג את כל עלויות הקרדיטים. שחקנים משחקים בחינם.",

  // ── Builder: General Panel (Actions) ──
  wb_gen_actions: "פעולות",
  wb_gen_actions_desc: "שכפל או מחק את העולם הזה",
  wb_gen_clone_world: "שכפל עולם זה",
  wb_gen_delete_world: "מחק עולם",
  wb_gen_clone_dialog_title: "שכפל עולם",
  wb_gen_clone_dialog_desc: "יוצר עותק מלא כולל כל הישויות, עלילות, סוכנים, תרחישים, רשימות ושירים.",
  wb_gen_new_world_name: "שם העולם החדש",
  wb_gen_clone_btn: "שכפל",
  wb_gen_delete_dialog_title: "מחק עולם",
  wb_gen_delete_dialog_desc: "פעולה זו תמחק לצמיתות את \"{name}\" וכל הישויות, העלילות, הסוכנים, התרחישים והמדיה שלו.",
  wb_gen_delete_cannot_undo: "לא ניתן לבטל פעולה זו.",
  wb_gen_delete_permanently: "מחק לצמיתות",

  // ── Builder: Entities Panel ──
  wb_ent_no_entities: "אין ישויות עדיין",
  wb_ent_no_entities_desc: "תאר את העולם שלך בצ׳אט וה-AI ייצור ישויות אוטומטית.",
  wb_ent_search: "חפש ישויות...",
  wb_ent_no_match: "אין ישויות התואמות לתצוגה זו.",

  // ── Builder: Plot Panel ──
  wb_plot_quests: "משימות",
  wb_plot_story: "סיפור",
  wb_plot_conditions: "תנאים",
  wb_plot_quests_desc: "משימות ראשיות וצדדיות עם יעדים וקישורים לתרחישים.",
  wb_plot_story_desc: "רגעים מרכזיים, אירועים, רמזי עלילה, עימותים וידע.",
  wb_plot_conditions_desc: "תנאי ניצחון, הפסד וסיום.",
  wb_plot_objectives: "יעדים",
  wb_plot_add_objective: "הוסף יעד...",
  wb_plot_relevance_critical: "קריטי",
  wb_plot_relevance_high: "גבוה",
  wb_plot_relevance_medium: "בינוני",
  wb_plot_relevance_low: "נמוך",
  wb_plot_relevance_background: "רקע",
  wb_plot_new_entry: "רשומה חדשה",
  wb_plot_no_entries: "אין רשומות עדיין.",

  // ── Builder: Scenarios Panel ──
  wb_sc_desc: "הגדר תרחישי התחלה — תבניות שמעצבות כיצד הרפתקאות מתחילות.",
  wb_sc_new: "תרחיש חדש",
  wb_sc_no_scenarios: "אין תרחישים עדיין.",
  wb_sc_no_scenarios_desc: "צור תרחישים כדי לתת לשחקנים נקודות התחלה מובנות. ללא תרחישים, הרפתקאות מתחילות בצורה חופשית.",
  wb_sc_create_first: "צור תרחיש ראשון",
  wb_sc_default: "ברירת מחדל",
  wb_sc_set_default: "הגדר כברירת מחדל",
  wb_sc_title: "כותרת",
  wb_sc_description: "תיאור",
  wb_sc_opening: "סיפור פתיחה",
  wb_sc_starting_location: "מיקום התחלתי",
  wb_sc_difficulty: "רמת קושי",
  wb_sc_allow_custom: "אפשר דמויות מותאמות",
  wb_sc_guidelines: "הנחיות לדמויות מותאמות",
  wb_sc_progressions: "התקדמויות סיפור",
  wb_sc_add_progression: "הוסף התקדמות",
  wb_sc_characters: "דמויות זמינות",
  wb_sc_tags: "תגיות",
  wb_sc_needs_title: "תרחיש צריך כותרת",

  // ── Builder: Players Panel ──
  wb_pc_title: "דמויות שחקן",
  wb_pc_desc: "דמויות מוכנות מראש שהשחקנים יכולים לבחור כשהם מתחילים הרפתקה.",
  wb_pc_new: "דמות חדשה",
  wb_pc_no_characters: "אין דמויות שחקן עדיין.",
  wb_pc_no_characters_desc: "צור דמויות שהשחקנים יוכלו לבחור, או תן להם ליצור משלהם.",
  wb_pc_create_first: "צור דמות ראשונה",
  wb_pc_identity: "זהות",
  wb_pc_backstory: "סיפור רקע",
  wb_pc_personality: "אישיות",
  wb_pc_stats: "נתונים",
  wb_pc_inventory: "מלאי",

  // ── Builder: Mechanics Panel ──
  wb_mech_search: "חפש מכניקות...",
  wb_mech_allow_dynamic: "אפשר מכניקות דינמיות",
  wb_mech_allow_dynamic_desc: "אפשר ל-AI להוסיף/להסיר מכניקות במהלך המשחק",
  wb_mech_active: "פעיל",
  wb_mech_guidance_placeholder: "תאר כיצד מכניקה זו מתבטאת בעולמך — מי שולט בה, היכן ניתן לגשת אליה, מה נדרש ברמה הנרטיבית.",

  // ── Builder: Agent Chat Dialog ──
  wb_agent_select_npc: "בחר NPC…",
  wb_agent_describe_self: "תאר מי אתה…",
  wb_agent_select_location: "בחר מיקום…",
  wb_agent_location_example: "פונדק חשוך…",
  wb_agent_time_example: "ערב מאוחר…",
  wb_agent_context_example: "מה קרה עכשיו, מצב רוח…",

  // ── Builder: Agent Editor ──
  wb_agent_no_linked_entity: "אין ישות מקושרת",
  wb_agent_traits_placeholder: "אמיץ, ערמומי, אדיב...",
  wb_agent_values_placeholder: "כבוד, חופש, ידע...",
  wb_agent_fears_placeholder: "נטישה, אש...",
  wb_agent_goals_placeholder: "מצא את החפץ, הגן על הכפר...",
  wb_agent_speech_patterns_placeholder: "מדבר בחידות, משתמש במטאפורות...",
  wb_agent_verbal_tics_placeholder: "'אכן', מנקה גרון, נאנח...",
  wb_agent_use_world_default: "השתמש בברירת מחדל של העולם",
  wb_agent_use_default_model: "השתמש במודל ברירת מחדל",

  // ── Builder: Checklist Panel ──
  wb_checklist_task_name: "לדוגמה: צור מערכת קסם",
  wb_checklist_task_desc: "תיאור קצר",
  wb_checklist_task_prompt: "ההודעה שנשלחת ל-AI כשלוחצים...",

  // ── Builder: Context Panel ──
  wb_context_desc_placeholder: "הוסף תיאור עולם...",

  // ── Builder: Custom Rules Editor ──
  wb_rule_title_placeholder: "לדוגמה: מחסום שפה",
  wb_rule_text_placeholder: "תאר את הכלל שה-AI צריך לפעול לפיו...",

  // ── Builder: Entities Panel ──
  wb_ent_search_placeholder: "חפש ישויות...",

  // ── Builder: Entity Detail Dialog ──
  wb_ent_add_tag: "הוסף_תגית...",
  wb_ent_json_data: "נתוני JSON",
  wb_ent_refine_instructions: "לדוגמה: התמקד בהיסטוריה הצבאית, הוסף דוגמאות דיאלוג נוספות...",
  wb_ent_name_placeholder: "שם ישות",
  wb_ent_tag_input: "הוסף תג...",
  wb_ent_desc_detail: "תאר את הישות בפירוט...",

  // ── Builder: Entity Property Helpers ──
  wb_ent_custom_field: "שדה_מותאם",

  // ── Builder: General Panel ──
  wb_gen_promo_section_placeholder: "טקסט פרסומי לקטע זה… השאר ריק כדי להציג תרחישים במקום.",

  // ── Builder: Group Chat Dialog ──
  wb_group_location_placeholder: "פונדק, אולם כס המלכות...",
  wb_group_time_placeholder: "ערב, אחרי הקרב...",

  // ── Builder: Initial Threads Editor ──
  wb_thread_desc_placeholder: "על מה חוט נרטיבי זה? לדוגמה: 'שיירת סוחרים נעלמה על הדרך הצפונית...'",
  wb_thread_hook_placeholder: "כיצד זה יכול להופיע לראשונה בסיפור...",

  // ── Builder: Player Characters Panel ──
  wb_pc_backstory_placeholder: "הזן סיפור רקע כטקסט או הדבק JSON מובנה...",
  wb_pc_name_placeholder: "אלדריק האמיץ",
  wb_pc_class_placeholder: "לוחם, קוסם, נוכל...",
  wb_pc_desc_placeholder: "אביר נודד המחפש גאולה...",
  wb_pc_playstyle_placeholder: "אגרסיבי, דיפלומטי, חשאי...",

  // ── Builder: Relationship Editor ──
  wb_rel_search_entities: "חפש ישויות...",
  wb_rel_custom_name: "או הקלד שם מותאם...",
  wb_rel_type_search: "הקלד או חפש...",
  wb_rel_custom_type: "סוג מותאם...",
  wb_rel_desc: "תיאור (אופציונלי)",
  wb_rel_notes: "הערות (אופציונלי)",

  // ── Builder: Scenarios Panel ──
  wb_sc_title_placeholder: "יער החשכה מתעורר...",
  wb_sc_desc_placeholder: "סקירה קצרה שהשחקנים יראו בעת הבחירה...",
  wb_sc_opening_placeholder: "הטקסט שהשחקנים קוראים כשההרפתקה מתחילה...",
  wb_sc_location_placeholder: "הפונדק המעורפל",
  wb_sc_guidelines_placeholder: "לדוגמה: הדמויות חייבות להיות בני אדם, ללא משתמשי קסם...",
  wb_sc_path_name: "שם נתיב",
  wb_sc_path_desc: "תיאור",
  wb_sc_item_name: "שם פריט",
  wb_sc_item_qty: "כמות",
  wb_sc_item_category: "קטגוריה",
  wb_sc_item_rarity: "נדירות",
  wb_sc_tags_placeholder: "מסתורין, קרבות כבדים, חקר...",

  // ── Builder: Share World Dialog ──
  wb_share_email_placeholder: "אימייל משתמש...",

  // ── Builder: Source References Panel ──
  wb_src_title_placeholder: "כותרת (לדוגמה: ויקיית Star Wars Fandom)",
  wb_src_url_placeholder: "URL (אופציונלי)",
  wb_src_desc_placeholder: "תיאור קצר",

  // ── Builder: Style References Panel ──
  wb_style_label_placeholder: "לדוגמה: סגנון מיקום",

  // ── Builder: Template Selector ──
  wb_template_search: "חפש תבניות...",

  // ── Builder: Voice Controls Panel ──
  wb_voice_select_placeholder: "בחר קול...",
  wb_voice_id_placeholder_venice: "לדוגמה: af_sky",
  wb_voice_id_placeholder_elevenlabs: "לדוגמה: JBFqnCBsd6RMkjVDRZzb",
  wb_voice_sample_placeholder: "טקסט קצר לתצוגה מקדימה של הקול",
  wb_voice_describe_placeholder: "תאר קול... גבר עמוק, אישה רכה, מסתורי",

  // ── Builder: Art Direction Tab ──
  wb_art_direction_placeholder: "לדוגמה: תאורה כהה ומדאיגה, הרכב קולנועי...",
  wb_art_brief_manual_placeholder: "כתוב תיאור חזותי ידנית...",

  // ── Index / World Stats ──
  idx_characters: "דמות",
  idx_scenarios: "תרחיש",
  idx_entities: "ישות",
  idx_all_worlds: "כל העולמות",
  idx_all_worlds_admin: "כל העולמות (מנהל)",

  // ── Header Credits ──
  hdr_credits: "קרדיטים",
  hdr_credit_wallet: "ארנק קרדיטים",
  hdr_usage_dashboard: "לוח שימוש",
  hdr_pricing_rates: "תמחור ותעריפים",
  hdr_earn_credits: "הרוויח קרדיטים",
  hdr_ai_disabled: "כל תכונות ה-AI מושבתות",
  hdr_building_disabled: "בניית עולמות מושבתת (צריך 50+)",

  // ── Reset Password page ──
  reset_title_done: "הכל מוכן!",
  reset_title_new: "סיסמה חדשה",
  reset_desc_done: "הסיסמה שלך עודכנה. מפנה…",
  reset_desc_new: "בחר סיסמה חדשה לחשבון שלך",
  reset_redirecting: "מפנה ללוח הבקרה…",
  reset_link_expired: "ייתכן שהקישור הזה פג תוקף או אינו חוקי. אנא בקש איפוס סיסמה חדש.",
  reset_back_sign_in: "חזרה להתחברות",
  reset_new_password: "סיסמה חדשה",
  reset_confirm_password: "אשר סיסמה",
  reset_placeholder: "לפחות 6 תווים",
  reset_re_enter: "הזן סיסמה שוב",
  reset_updating: "מעדכן…",
  reset_update_button: "עדכן סיסמה",
  reset_password_min: "הסיסמה חייבת להכיל לפחות 6 תווים.",
  reset_passwords_mismatch: "הסיסמאות אינן תואמות.",
  reset_success: "הסיסמה עודכנה בהצלחה!",
  auth_remember_me: "זכור אותי",
  auth_err_invalid_creds: "אימייל או סיסמה שגויים. אנא נסה שנית.",
  auth_err_email_not_confirmed: "אנא אמת את כתובת האימייל שלך לפני הכניסה. בדוק את תיבת הדואר.",
  auth_err_user_exists: "חשבון עם אימייל זה כבר קיים. נסה להתחבר.",
  auth_err_password_too_short: "הסיסמה חייבת להכיל לפחות 6 תווים.",
  auth_err_rate_limit: "יותר מדי ניסיונות. אנא המתן רגע ונסה שוב.",
  auth_err_signup_disabled: "הרשמה חדשה מושבתת כרגע.",
  auth_err_generic: "אירעה שגיאה. אנא נסה שנית.",
  common_generating: "מייצר...",
  common_processing: "מעבד...",
  common_resume: "המשך",
  common_pause: "השהה",
  common_generate: "צור",
  common_saving: "שומר...",
  wb_voice_save: "שמור הגדרות קול",
  wb_agent_auto_generate: "יצירה אוטומטית",
  wb_doc_generate_codex: "צור קודקס",
  wb_doc_status_vector: "וקטור",
  wb_doc_status_text: "טקסט",
  wb_doc_status_error: "שגיאה",
  wb_doc_indexed: "מאונדקס לחיפוש",
  wb_doc_timeout: "ייתכן שההעלאה חרגה מזמן",
  wb_doc_still_processing: "עדיין מעבד...",
  wb_doc_error_processing: "שגיאה בעיבוד",
  wb_map_rename: "שנה שם",
  wb_map_upload_image: "העלה תמונת מפה",
  wb_map_upload_overlay: "העלה שכבת מפה",
  wb_map_generate_ai: "צור מפה עם AI",
  play_tts_disabled: "טקסט לדיבור ({provider}) מושבת כרגע עבור חשבונך.",
  play_setup_char_name: "שם הדמות...",
  play_setup_char_desc: "תיאור קצר של הדמות (ה-AI יעזור להרחיב)...",
  play_setup_adventure_name: "שם ההרפתקה...",
  gm_ask_placeholder: "שאל את ה-GM… (Shift+Enter לשורה חדשה)",
  notes_title_placeholder: "כותרת פתק…",
  notes_content_placeholder: "כתוב את הפתק שלך…",
  notes_untitled: "ללא כותרת",
  notes_untitled_note: "פתק ללא כותרת",
  social_search_placeholder: "חפש לפי שם או דוא״ל...",
  social_no_users: "לא נמצאו משתמשים",
  social_search_failed: "החיפוש נכשל",
  social_find_players: "מצא שחקנים",
  social_friend_requests: "בקשות חברות",
  social_friends: "אנשי קשר",
  social_no_friends: "אין אנשי קשר עדיין. חפש שחקנים למעלה!",
  social_sent_requests: "בקשות שנשלחו",
  wb_rename_failed: "שינוי שם העולם נכשל",
  wb_rename_tooltip: "לחץ לשינוי שם",
  msg_page_title: "הודעות",
  msg_unknown_contact: "לא ידוע",
  chat_conversation_reset: "השיחה אופסה",
  chat_send_failed: "שליחת ההודעה נכשלה",
  chat_no_messages: "אין הודעות עדיין. אמור שלום!",
  chat_type_message: "הקלד הודעה...",

  // ── Accessible button labels (aria-label) ──
  aria_send_message: "שלח הודעה",
  aria_message_options: "אפשרויות הודעה",
  aria_edit_message: "ערוך הודעה",
  aria_delete_message: "מחק הודעה",
  aria_roll_dice: "הטל קוביות",
  aria_notifications: "התראות",
  notif_mark_all_read: "סמן הכל כנקרא",
  notif_empty: "אין התראות",
  aria_pause_narration: "השהה נרציה",
  aria_resume_narration: "המשך נרציה",
  aria_stop_narration: "עצור נרציה",
  aria_replay_narration: "הפעל שוב נרציה",
  aria_next_track: "דלג לרצועה הבאה",

  // ── useMultiplayerAdventure ──
  adv_load_failed: "טעינת ההרפתקה נכשלה: {error}",
  adv_your_turn: "⚔️ התור שלך!",
  adv_your_turn_desc: "תור {name} לפעול",
  adv_create_failed: "יצירת ההרפתקה נכשלה: {error}",
  adv_invalid_invite: "קוד הזמנה לא תקין",
  adv_joined: "הצטרפת להרפתקה!",
  adv_join_failed: "ההצטרפות נכשלה: {error}",
  adv_no_retry_msg: "לא נמצאה הודעת משתמש לניסיון חוזר",
  adv_orphaned_removed: "הודעה יתומה הוסרה",
  adv_msg_delete_failed: "מחיקת ההודעה נכשלה",
  adv_msg_deleted: "ההודעה נמחקה",
  adv_msg_edit_failed: "עריכת ההודעה נכשלה",
  adv_msg_updated: "ההודעה עודכנה",

  // ── useFriends ──
  friends_request_exists: "בקשת חברות כבר קיימת",
  friends_request_failed: "שליחת בקשת החברות נכשלה",
  friends_request_sent: "בקשת חברות נשלחה!",
  friends_accept_failed: "קבלת הבקשה נכשלה",
  friends_request_accepted: "בקשת החברות התקבלה!",
  friends_decline_failed: "דחיית הבקשה נכשלה",
  friends_request_declined: "בקשת החברות נדחתה",
  friends_remove_failed: "הסרת החבר נכשלה",
  friends_removed: "החבר הוסר",

  // ── useIndexData (Index page actions) ──
  idx_load_failed: "טעינת הנתונים נכשלה",
  idx_file_too_large: "{name} גדול מדי (מקסימום 2MB)",
  idx_file_read_failed: "לא ניתן לקרוא את {name}",
  idx_need_credits: "צריך לפחות 50 קרדיטים ליצירת עולם",
  idx_create_world_failed: "יצירת העולם נכשלה: {error}",
  idx_world_trashed: "העולם הועבר לאשפה",
  idx_world_restored: "העולם שוחזר",
  idx_world_perm_deleted: "העולם נמחק לצמיתות",
  idx_world_published: "העולם פורסם!",
  idx_world_unpublished: "הפרסום בוטל",
  idx_world_cloned: "העולם שוכפל בהצלחה!",
  idx_clone_failed: "השכפול נכשל: {error}",
  idx_adventure_deleted: "ההרפתקה נמחקה",
  idx_adventure_left: "עזבת את ההרפתקה",
  idx_adventure_joined: "הצטרפת להרפתקה!",
  idx_invalid_invite: "קוד הזמנה לא תקין",
  idx_invite_copied: "קישור ההזמנה הועתק!",
  idx_delete_failed: "המחיקה נכשלה: {error}",
  idx_restore_failed: "השחזור נכשל: {error}",
  idx_update_failed: "העדכון נכשל: {error}",
  idx_leave_failed: "העזיבה נכשלה: {error}",
  idx_join_failed: "ההצטרפות נכשלה: {error}",
  idx_start_game_failed: "הפעלת המשחק נכשלה: {error}",

  // ── DocumentUpload ──
  doc_file_too_large: "{name} גדול מדי (מקסימום 20MB)",
  doc_file_already_exists: "\"{name}\" כבר קיים בבסיס הידע",
  doc_file_empty: "{name} ריק",
  doc_file_duplicate_content: "\"{name}\" תוכן זהה למסמך קיים",
  doc_upload_success: "{name} → {chunks} קטעים ({category})",
  doc_upload_failed: "נכשל: {error}",
  doc_no_supported_files: "אין קבצים נתמכים. השתמש ב: {types}",
  doc_deleted: "{name} נמחק",
  doc_delete_failed: "המחיקה נכשלה: {error}",
  doc_removed_stuck: "הוסר \"{name}\" תקוע — אנא העלה מחדש",
  doc_reindexed: "{name} אינדקס מחדש: {chunks} קטעים",
  doc_reindex_failed: "אינדוקס מחדש נכשל: {error}",
  doc_codex_regenerated: "קודקס נוצר מחדש עבור {name}",
  doc_codex_failed: "יצירת קודקס נכשלה: {error}",
  doc_reanalyzed: "{name} נותח מחדש: {chunks} קטעים ({mode})",
  doc_reanalyze_failed: "ניתוח מחדש נכשל: {error}",

  // ── ShareWorldDialog ──
  share_link_copied: "קישור השיתוף הועתק!",
  share_copy_failed: "ההעתקה נכשלה",
  share_load_collab_failed: "טעינת שיתופי הפעולה נכשלה",
  share_user_not_found: "לא נמצא משתמש עם האימייל הזה. עליהם להירשם תחילה.",
  share_cannot_add_self: "לא ניתן להוסיף את עצמך כשותף.",
  share_already_collab: "משתמש זה כבר שותף פעולה.",
  share_collab_added: "נוסף {email} כשותף {role}",
  share_add_collab_failed: "הוספת שותף נכשלה: {error}",
  share_permission_updated: "ההרשאה עודכנה",
  share_update_failed: "העדכון נכשל: {error}",
  share_collab_removed: "שותף הפעולה הוסר",
  share_remove_failed: "ההסרה נכשלה: {error}",

  // ── useCreditBalance ──
  cred_img_disabled: "יצירת תמונות מושבתת",
  cred_img_disabled_desc: "היתרה ירדה מתחת ל-{threshold} קרדיטים ({balance}). יצירת תמונות מושבתת כעת לשמירת קרדיטים.",
  cred_running_low: "קרדיטים אוזלים",
  cred_running_low_desc: "היתרה שלך היא {balance} קרדיטים. כדאי לצמצם שימוש.",
  cred_voice_disabled: "יצירת קול מושבתת",
  cred_voice_disabled_desc: "היתרה ירדה מתחת ל-{threshold} קרדיטים ({balance}). תכונות קול/TTS מושבתות כעת.",
  cred_transfer_disabled: "העברת קרדיטים מושבתת",
  cred_transfer_disabled_desc: "היתרה ירדה מתחת ל-{threshold} קרדיטים ({balance}). העברות קרדיטים מושבתות כעת.",
  cred_build_disabled: "בניית עולמות מושבתת",
  cred_build_disabled_desc: "היתרה ירדה מתחת ל-{threshold} קרדיטים ({balance}). יצירת עולמות ותכונות בנייה מושבתות כעת.",
  cred_all_disabled: "כל תכונות הקרדיטים מושבתות",
  cred_all_disabled_desc: "יתרת הקרדיטים שלך הגיעה ל-0. כל התכונות המבוססות על AI מושבתות עד שתקבל קרדיטים נוספים.",

  // ── GeneralPanel ──
  gen_world_saved: "פרטי העולם נשמרו",
  gen_save_failed: "שמירה נכשלה: {error}",
  gen_promo_generated: "טקסט פרסומי נוצר!",
  gen_copied_clipboard: "הועתק ללוח",
  gen_intro_applied: "מבוא הוחל על התיאור",
  gen_all_langs_translated: "לכל השפות כבר יש תרגומים",
  gen_translations_generated: "תרגומים נוצרו!",
  gen_generation_failed: "יצירה נכשלה",
  gen_translation_failed: "תרגום נכשל",

  // ── WorldMapEditor ──
  map_layer_placed: "שכבה הוצבה על המפה",
  map_polygon_created: "אזור מצולע נוצר",
  map_connection_added: "חיבור נוסף",
  map_placed_locations: "הוצבו {count} מיקומים",
  map_failed_suffix: "({count} נכשלו)",
  map_geocode_failed: "לא ניתן לקדד {count} מיקומים",
  map_all_placed: "כל המיקומים כבר הוצבו",
  map_cannot_resolve: "לא ניתן למצוא מיקום מפה מודרני עבור \"{name}\"",
  map_moved_via: "\"{name}\" הועבר דרך \"{query}\"",
  map_fix_failed: "תיקון AI נכשל: {error}",
  map_variant_created: "גרסה \"{name}\" נוצרה",
  map_variant_duplicated: "גרסה שוכפלה",
  map_connection_removed: "חיבור הוסר",
  map_added_layer: "נוסף כשכבה",
  map_add_layer_failed: "הוספת שכבה נכשלה",
  map_drawing_saved: "ציור השכבה נשמר",
  map_save_drawing_failed: "שמירת הציור נכשלה: {error}",
  map_ai_layer_generated: "שכבת AI נוצרה",
  map_ai_no_image: "היצירה לא החזירה תמונה",
  map_ai_generation_failed: "יצירת AI נכשלה: {error}",
  map_switched_to: "עבר ל-{type}",
  map_linked_to: "המפה קושרה ל-{name}",
  map_unlinked: "המפה נותקה מהמיקום",
  map_placed_coords: "הוצב \"{label}\" ב-{lat}, {lng}",
  map_geocode_not_found: "לא נמצא \"{address}\"",
  map_geocode_error: "שגיאת גיאוקודינג: {error}",
  map_placed_via: "הוצב \"{name}\" דרך \"{query}\"",
  map_default_view_saved: "תצוגת ברירת המחדל נשמרה ({lat}, {lng} z{zoom})",

  // ── import-utils ──
  imp_loading_world: "מייבא תבנית עולם…",
  imp_invalid_world_file: "קובץ ייצוא לא תקין. נדרש ייצוא תבנית עולם.",
  imp_sign_in_required: "יש להיות מחובר כדי לייבא.",
  imp_world_success: "עולם יובא! {summary}",
  imp_failed: "ייבוא נכשל: {error}",
  imp_loading_game: "מייבא מופע משחק…",
  imp_invalid_game_file: "קובץ ייצוא לא תקין. נדרש ייצוא מופע משחק.",
  imp_game_success: "מופע משחק יובא! {messages} הודעות, {entities} ישויות",
  imp_resetting: "מאפס דריסות הרפתקה…",
  imp_reset_success: "דריסות ההרפתקה אופסו!",
  imp_reset_failed: "האיפוס נכשל: {error}",

  // ── export-utils ──
  exp_loading_world: "מייצא תבנית עולם…",
  exp_world_success: "תבנית העולם יוצאה!",
  exp_failed: "הייצוא נכשל: {error}",
  exp_loading_player: "מייצא נתוני שחקן…",
  exp_player_success: "נתוני שחקן יוצאו!",
  exp_loading_game: "מייצא מופע משחק…",
  exp_game_success: "מופע משחק יוצא!",

  // ── ImageGenerationDialog ──
  img_gen_disabled: "יצירת תמונות מושבתת כרגע עבור חשבונך. צור קשר עם מנהל להפעלה.",
  img_only_images: "רק קבצי תמונה נתמכים",
  img_ref_uploaded: "תמונת ייחוס הועלתה",
  img_upload_failed: "ההעלאה נכשלה: {error}",
  img_draft_loaded: "טיוטה נטענה",
  img_draft_deleted: "טיוטה נמחקה",
  img_drawing_saved: "ציור נשמר לגלריית מדיה",
  img_drawing_save_failed: "שמירת הציור נכשלה: {error}",
  img_generated: "תמונה נוצרה — בדוק וקבל או נסה שוב",
  // ── useWorldBuilderAgent ──
  wb_load_failed: "טעינת העולם נכשלה: {error}",
  wb_create_failed: "יצירת העולם נכשלה: {error}",
  wb_world_saved: "העולם נשמר בהצלחה",
  wb_save_failed: "השמירה נכשלה: {error}",
  wb_credits_required: "בניית עולמות מושבתת — דרושים לפחות 50 קרדיטים",
  wb_agent_error: "שגיאת סוכן: {error}",
  // ── World ready celebration ──
  wb_world_ready_title: "🎉 העולם שלך מוכן!",
  wb_world_ready_desc: "חקרו את הקודקס, כווננו את הפרטים, או צאו להרפתקה.",
  // ── useTTS ──
  tts_no_voice: "טרם הוגדר קול נרטור (הגדר אחד בבונה העולמות → הקשר)",
  tts_no_voice_short: "לא הוגדר קול נרטור",
  tts_downloaded: "האודיו הורד",
  tts_download_failed: "הורדת האודיו נכשלה",
  // ── useFeatureFlags ──
  ff_locked: "תכונה זו נעולה על ידי מנהל מערכת.",
  ff_update_failed: "עדכון דגל התכונה נכשל",
  ff_lock_failed: "עדכון הנעילה נכשל",
  ff_update_flags_failed: "עדכון דגלי התכונות נכשל",
  // ── StyleReferencesPanel ──
  sref_added: "עיון בסגנון נוסף",
  sref_upload_failed: "ההעלאה נכשלה: {error}",
  sref_delete_failed: "המחיקה נכשלה",
  sref_removed: "העיון הוסר",
  // ── TrashManagerDialog ──
  trash_load_failed: "טעינת הפח נכשלה: {error}",
  trash_restored: "\"{name}\" שוחזר",
  trash_restore_failed: "השחזור נכשל: {error}",
  trash_deleted: "\"{name}\" נמחק לצמיתות",
  trash_delete_failed: "המחיקה נכשלה: {error}",
  trash_emptied: "הפח רוקן",
  trash_empty_failed: "ריקון הפח נכשל: {error}",
  // ── ChecklistPanel ──
  check_title_required: "כותרת נדרשת",
  check_updated: "עודכן",
  check_added: "נוסף",
  check_reset: "הרשימה אופסה לברירת המחדל",
  check_all_done: "כל הפריטים כבר הושלמו!",
  check_queued: "נוספו לתור {count} משימות לבינה מלאכותית (כולל סקירה סופית)",
  // ── ReportContentButton ──
  rep_sign_in_required: "יש להתחבר כדי לדווח על תוכן.",
  rep_already_reported: "כבר דיווחת על תוכן זה. הצוות שלנו בוחן את הדיווח.",
  rep_submitted: "הדיווח נשלח. תודה שאתה עוזר לשמור על AdVent בטוח.",
  rep_submit_failed: "שליחת הדיווח נכשלה",
  rep_try_later: "אנא נסה שוב מאוחר יותר.",
  // ── useMapVariants ──
  var_create_failed: "יצירת הגרסה נכשלה",
  var_update_failed: "עדכון הגרסה נכשל",
  var_delete_last: "לא ניתן למחוק את הגרסה האחרונה",
  var_delete_failed: "מחיקת הגרסה נכשלה",
  var_active_failed: "הגדרת הגרסה הפעילה נכשלה",
  // ── useMapUploads ──
  upl_map_uploaded: "תמונת המפה הועלתה",
  upl_upload_failed: "ההעלאה נכשלה",
  upl_layer_added: "שכבה נוספה",
  upl_layer_failed: "העלאת השכבה נכשלה",
  upl_base_assigned: "הוגדרה כמפת בסיס",
  upl_map_applied: "תמונת המפה הוחלה",
  upl_svg_applied: "מפת SVG הוחלה",
  // ── Map editor / canvas placeholders ──
  map_node_label_placeholder: "תווית (לדוג' Castle Rock)",
  map_lat_placeholder: "קו רוחב",
  map_lng_placeholder: "קו אורך",
  map_address_placeholder: "כתובת או שם מקום...",
  map_search_nodes_placeholder: "חיפוש צמתים...",
  map_connection_desc_placeholder: "מעבר מסוכן...",
  map_search_nodes_places_placeholder: "חיפוש צמתים או מקומות...",
  map_location_name_placeholder: "שם המיקום...",
  map_voice_default_placeholder: "ברירת מחדל",
  map_search_locations_placeholder: "חיפוש מיקומים...",
  map_node_desc_placeholder: "תיאור קצר (אופציונלי)...",
  map_name_placeholder: "מפת העולם",
  map_all_locations_filter: "כל המיקומים (ללא סינון)",
  map_node_image_url: "https://... או השאר ריק לאייקון",
  map_node_tags_placeholder: "לדוגמה: טריטוריית סיעה, אוכלוסייה...",
  map_style_json_url: "https://example.com/style.json",
  // ── useMapNodes ──
  node_create_failed: "יצירת הצומת נכשלה",
  node_delete_failed: "מחיקת הצומת נכשלה",
  node_save_partial: "שמירת חלק מהשינויים נכשלה",
  node_saved: "המפה נשמרה",
  node_save_failed: "שמירת המפה נכשלה: {error}",
  // ── MediaGallery ──
  media_img_generated: "תמונה נוצרה!",
  media_generation_failed: "היצירה נכשלה",
  media_delete_failed: "המחיקה נכשלה",
  media_update_failed: "העדכון נכשל",
  media_set_main: "הוגדרה כתמונה ראשית",
  media_disconnect_failed: "ניתוק הישות נכשל",
  media_archived: "התמונה הועברה לארכיון (נותקה מהישות)",
  // ── EntityDetailDialog ──
  ent_updated: "הישות עודכנה",
  ent_save_failed: "שמירה נכשלה: {error}",
  ent_trashed: '"{name}" הועבר לאשפה',
  ent_delete_failed: "המחיקה נכשלה: {error}",
  ent_id_copied: "מזהה הישות הועתק",
  ent_deactivated: "{name} הושבת",
  ent_activated: "{name} הופעל",
  ent_dormant: "{name} במצב רדום",
  ent_active: "{name} פעיל",
  // ── CreditWalletPanel ──
  cw_invalid_amount: "הזן סכום תקין",
  cw_balance_low: "העברות קרדיט מושבתות כאשר יתרתך נמוכה מ-100",
  cw_min_transfer: "סכום העברה מינימלי הוא 100 קרדיטים",
  cw_insufficient: "קרדיט לא מספיק",
  cw_sent: "נשלחו {amount} קרדיטים!",
  // ── AgentEditor / AgentChatDialog / GroupChatDialog ──
  agent_needs_name: "הסוכן צריך שם",
  agent_saved: "הסוכן נשמר",
  agent_deleted: "הסוכן נמחק",
  agent_chat_failed: "צ'אט נכשל: {error}",
  agent_group_failed: "צ'אט קבוצתי נכשל: {error}",
  // ── World builder misc components ──
  ctx_desc_update_failed: "עדכון התיאור נכשל",
  guidance_save_failed: "שמירה נכשלה: {error}",
  guidance_saved: "הנחיות תמונה נשמרו",
  banner_save_failed: "שמירת הבאנר נכשלה: {error}",
  banner_removed: "הבאנר הוסר",
  banner_remove_failed: "הסרת הבאנר נכשלה: {error}",
  icon_save_failed: "שמירת הסמל נכשלה: {error}",
  icon_removed: "הסמל הוסר",
  icon_remove_failed: "הסרת הסמל נכשלה: {error}",
  src_ref_add_failed: "הוספת הפניה נכשלה",
  src_ref_deleted: "ההפניה נמחקה",
  src_ref_update_failed: "עדכון נכשל",
  pc_updated: "הדמות עודכנה",
  pc_created: "הדמות נוצרה",
  pc_needs_name: "הדמות צריכה שם תחילה",
  adv_inst_save_failed: "שמירת השינויים נכשלה",
  auto_gen_complete: "יצירת העולם הושלמה!",
  voice_saved: "הגדרות הקול נשמרו",
  gen_themes_generated: "ז'אנר ונושאים נוצרו!",
  // ── useWorldMaps / useMapEntityActions ──
  wmap_create_failed: "יצירת המפה נכשלה",
  wmap_update_failed: "עדכון המפה נכשל",
  wmap_delete_failed: "מחיקת המפה נכשלה",
  mea_create_failed: "יצירת מיקום נכשלה: {error}",
  mea_gen_failed: "יצירה נכשלה: {error}",
  wh_download_failed: "ההורדה נכשלה",
  // ── Play components ──
  play_msg_updated: "ההודעה עודכנה",
  play_snapshot_downloaded: "תמונת המשחק הורדה",
  play_snapshot_failed: "בניית תמונת מצב נכשלה",
  play_downloaded: "הורד",
  // ── Map components ──
  map_lib_added: "תמונת מפה נוספה לספרייה",
  map_lib_removed: "הוסרה מהספרייה",
  svg_traced: "SVG עובד בהצלחה",
  svg_lib_saved: "SVG נשמר לספרייה",
  // ── MusicLibraryPanel / imagegen ──
  music_not_auth: "לא מאומת",
  music_group_update_failed: "עדכון הקבוצה נכשל",
  draft_started: "טיוטה חדשה התחילה",
  draw_seed_saved: "הציור נשמר כזרע ולגלריית המדיה",
  // ── Settings / Profile / Layout ──
  byok_saved: "הגדרות BYOK נשמרו",
  ai_enter_key: "הכנס מפתח API תחילה",
  app_bg_reset: "אופס לרקע ברירת המחדל",
  custom_ai_saved: "הגדרות AI מותאמות נשמרו!",
  custom_ai_save_failed: "שמירה נכשלה: {error}",
  custom_ai_name_placeholder: "AI מותאם",
  custom_ai_model_placeholder: "לדוגמה: gpt-4o, mistral-large, וכו'",
  custom_ai_endpoint_placeholder: "https://your-endpoint.com/v1/chat/completions",
  custom_ai_key_placeholder: "הכנס מפתח API",
  custom_ai_instructions_placeholder: "הוראות מותאמות עבור {label}…",
  settings_activity_filter_user: "סנן לפי user_id (UUID אופציונלי)…",
  settings_activity_search: "חפש ביומנים...",
  settings_credit_email: "user@example.com",
  settings_error_search: "חפש שגיאות...",
  settings_tool_search_query: "הכנס שאילתת חיפוש...",
  settings_tool_fetch_url: "URL לשליפה דרך proxy",
  settings_tool_franchise_slug: "מזהה זכיינות (לדוגמה: lotr, starwars, fallout)",
  mod_notes_placeholder: "הערות פנימיות על ההחלטה (גלויות לאדמינים בלבד).",
  mod_report_details: "הוסף כל מידע שיעזור לנו להבין את הבעיה.",
  byok_api_key_placeholder: "הדבק את מפתח ה-API שלך…",
  byok_account_name_placeholder: "שם חשבון",
  byok_use_default: "השתמש בברירת מחדל",
  byok_endpoint_url: "https://api.openai.com/v1/chat/completions",
  ref_link_copied: "קישור הפניה הועתק!",
  copy_failed: "ההעתקה נכשלה",
  sign_out_failed: "שגיאה בהתנתקות",
  admin_search_users: "חפש לפי שם, אימייל, או מזהה...",
  // ── Community ──
  forum_topic_created: "הנושא נוצר!",
  forum_topic_failed: "נכשל: {error}",
};
